// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:13:14.002Z
// Property: Linden at Southover (ID: 6767906449167459)
// Collections: 40 amenities, 14 floorplans (live), 50 photos, 75 POIs, 3 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6767906449167459",
  "property_external_id": "5666488",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/palms-at-chatham-savannah-ga/mdmdneh/",
  "property_google_business_url": "https://www.google.com/maps/place/Linden+at+Southover/@32.0415272,-81.1534803,17z/data=!3m1!4b1!4m6!3m5!1s0x88fb75586e1db723:0xf741272a92694018!8m2!3d32.0415272!4d-81.1534803!16s%2Fg%2F11wxb57cg7?entry=ttu&g_ep=EgoyMDI2MDcyMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "53883459436",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "linden-at-southover",
  "property_name": "Linden at Southover",
  "property_website_url": "https://www.lindenatsouthover.com",
  "property_domain": "https://www.lindenatsouthover.com",
  "property_address": "5110 Garrard Ave",
  "property_full_address": "5110 Garrard Ave, Savannah, GA 31405",
  "property_address_1": "5110 Garrard Ave",
  "property_address_2": null,
  "property_address_city": "Savannah",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "31405",
  "property_address_country": "US",
  "property_address_county": "Chatham County",
  "property_neighborhood_address": "Southwest Savannah",
  "property_address_latitude": "32.0403606",
  "property_address_longitude": "-81.1506299",
  "property_email": null,
  "property_phone": "(912) 244-8467",
  "property_call_tracking_phone": "912-452-5293",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>Welcome to Linden at Southover in beautiful Savannah, GA, where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans, each designed with high ceilings, stylish finishes, and private patios. Enjoy exceptional amenities like a resort-style pool, fitness center, and serene picnic areas. Your ideal home awaits!</p>",
  "property_long_description": "<p>Whether you're searching for a one-, two-bedroom or three-bedroom apartment home, you can find a floor plan that fits your needs at Linden at Southover. These beautifully-crafted apartment homes will welcome you in and invite you to a life of leisure and luxury.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
  "property_featured_image_media": {
    "alt_text": "Indoor lounge area with large windows overlooking the pool.",
    "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
    "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "300",
  "property_year_built": "2003",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97",
  "property_admin_fee": "250.00",
  "property_application_fee": "95.00",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs are welcome with no breed restrictions.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://9313310.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://lindenatsouthover.loftliving.com/login",
  "property_apply_now_url": "https://9313310.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-0e6e-7353-a86d-b53b9f3487fd.webp",
  "property_primary_logo_media": {
    "alt_text": "Linden at Southover logo",
    "public_id": "019eae32-0e6e-7353-a86d-b53b9f3487fd",
    "storage_key": "property/6767906449167459/019eae32-0e6e-7353-a86d-b53b9f3487fd.webp",
    "width": 3072,
    "height": 997
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-51a8-730a-9105-9c00b1ee9a33.webp",
  "property_secondary_logo_media": {
    "alt_text": "Linden at Southover logo",
    "public_id": "019eae32-51a8-730a-9105-9c00b1ee9a33",
    "storage_key": "property/6767906449167459/019eae32-51a8-730a-9105-9c00b1ee9a33.webp",
    "width": 3021,
    "height": 3072
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019e755e-76c5-73cc-8c9a-c973fe9f6e1a.webp",
  "property_icon_media": {
    "alt_text": "LS monogram logo",
    "public_id": "019e755e-76c5-73cc-8c9a-c973fe9f6e1a",
    "storage_key": "property/6767906449167459/019e755e-76c5-73cc-8c9a-c973fe9f6e1a.webp",
    "width": 2286,
    "height": 3072
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019e755e-76c5-73cc-8c9a-c973fe9f6e1a.webp",
  "property_fav_icon_media": {
    "alt_text": "LS monogram logo",
    "public_id": "019e755e-76c5-73cc-8c9a-c973fe9f6e1a",
    "storage_key": "property/6767906449167459/019e755e-76c5-73cc-8c9a-c973fe9f6e1a.webp",
    "width": 2286,
    "height": 3072
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae48-f382-7011-8908-aeaa88f7e541.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019eae48-f382-7011-8908-aeaa88f7e541",
    "storage_key": "property/6767906449167459/019eae48-f382-7011-8908-aeaa88f7e541.webp",
    "width": 1280,
    "height": 415
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae47-64ab-76be-bbe5-ed6c4ede1c4e.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019eae47-64ab-76be-bbe5-ed6c4ede1c4e",
    "storage_key": "property/6767906449167459/019eae47-64ab-76be-bbe5-ed6c4ede1c4e.webp",
    "width": 1280,
    "height": 415
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#515c34",
  "property_secondary_color": "#f2f1ea",
  "property_font_color": null,
  "property_color_4": "#4c3520",
  "property_color_3": "#2d2f22",
  "property_color_5": "#e1e5d8",
  "property_color_6": "#c1a387",
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "733 - 1214",
  "property_sqft_min": "733",
  "property_sqft_max": "1214",
  "property_price_range": "1769",
  "property_price_min": null,
  "property_price_max": "1769",
  "property_available_units": 168,
  "property_facebook_url": "https://www.facebook.com/Lindenatsouthover",
  "property_instagram_url": "https://www.instagram.com/lindenatsouthover/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/Linden+at+Southover/data=!4m2!3m1!1s0x0:0xf741272a92694018?sa=X&ved=1t:2428&ictx=111",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/oaks-at-brandlewood-savannah",
  "property_tiktok_url": "https://www.tiktok.com/@lindenatsouthover",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Linden at Southover",
  "property_home_romance_title": "Embrace Life and Love at Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Linden at Southover in Savannah, GA, where modern living meets luxurious comfort. Our diverse floor plans, from cozy one-bedroom retreats to spacious three-bedroom homes, cater to all lifestyles. Enjoy resort-style amenities, including a dazzling swimming pool and a dedicated yoga room, all within a secure, gated community.",
  "property_home_floorplans_blurb": "Welcome to Linden at Southover, where modern living meets Southern charm in Savannah, GA. Choose from our inviting one, two, or three-bedroom floor plans designed to suit your lifestyle. Embrace comfort and style—browse our available apartment homes and find the perfect space to call your own today!",
  "property_home_gallery_blurb": "Welcome to Linden at Southover, where modern living meets comfort in vibrant Savannah, GA. Choose from spacious one, two, or three-bedroom floor plans and enjoy top-tier amenities like a resort-style pool, dedicated yoga room, and a fenced dog park. Picture yourself living here, where every day feels like a getaway.",
  "property_home_neighborhood_blurb": "At Linden at Southover in Savannah, GA, diverse floor plans—one, two, and three bedrooms—nestle within a vibrant community. Enjoy an array of cultural gems nearby, from the enchanting SCAD Museum of Art and historic Trusts Theater to the lush expanses of Daffin Park. Life here blends comfort with dynamic exploration.",
  "property_home_reviews_blurb": "At Linden at Southover in Savannah, GA, residents rave about their home sweet home: “The staff is incredibly friendly, making you feel like family!” Experience a vibrant community filled with warmth and charm. See what our residents have to say about living at our community and join the celebration!",
  "property_neighborhood_blurb": "Nestled in peaceful Southwest Savannah, Linden at Southover offers the perfect blend of tranquility and convenience. With nearby shopping, dining, and entertainment, you’ll enjoy easy access to all the best the area has to offer.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "From our resort-style pool to our modern fitness center, every amenity at Linden at Southover is designed to make life easier, more enjoyable, and more connected.",
  "property_applynow_blurb": "At Linden at Southover in Savannah, GA, experience a vibrant lifestyle in our beautifully designed one, two, and three-bedroom apartments. Enjoy top-tier amenities like a resort-style pool, a 24-hour fitness center, and a welcoming outdoor picnic area. Your perfect home awaits—lease online today!",
  "property_contactus_blurb": "At Linden at Southover in charming Savannah, GA, diverse floor plans await to meet your lifestyle needs—from cozy one-bedrooms to spacious three-bedrooms. Experience comfortable living in vibrant surroundings. Ready to learn more? Have questions? Contact our leasing team today and let us help you find your perfect home!",
  "property_faqs_blurb": "At Linden at Southover in Savannah, GA, our diverse floor plans—ranging from cozy one-bedroom retreats to spacious three-bedroom havens—cater to every lifestyle. Have questions? Navigate to our FAQs page for insights and clarity about our vibrant community and what we have to offer!",
  "property_floorplans_blurb": "At Linden at Southover in charming Savannah, GA, find your ideal sanctuary among our thoughtfully designed one, two, and three-bedroom floor plans. Each layout combines style and comfort, tailored to enhance your living experience. Browse our available apartment homes and step into a space that truly feels like home.",
  "property_gallery_blurb": "Explore photos of our beautiful apartment homes, modern amenities, and vibrant community spaces designed to complement your Savannah lifestyle.",
  "property_interactivemap_blurb": "Welcome to Linden at Southover, where comfort meets style in Savannah, GA! Choose from spacious one, two, or three-bedroom apartments featuring modern amenities like a resort-style pool, fitness center, and a pet-friendly dog park. Navigate our interactive community map to find the perfect home that fits your lifestyle!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Linden at Southover in charming Savannah, GA, a welcoming community awaits with one, two, and three-bedroom floor plans designed for your lifestyle. Great friends make great neighbors—refer a friend today and enhance your living experience in our vibrant home. A lively community is just a referral away!",
  "property_residentaccess_blurb": "Welcome to Linden at Southover, where your ideal living space awaits in vibrant Savannah, GA! Choose from stylish one, two, or three-bedroom floor plans tailored to fit your lifestyle. Access your resident portal effortlessly to pay rent, schedule maintenance, and unlock a world of convenience at your fingertips!",
  "property_reviews_blurb": "At Linden at Southover in beautiful Savannah, GA, residents can’t stop raving about the warm community spirit and exceptional amenities. One happy resident notes, “The friendly atmosphere makes you feel right at home!” Dive into our reviews to hear more about what makes living here truly special!",
  "property_created_at": "1776693485956",
  "property_scheduletour_blurb": "At Linden at Southover in Savannah, GA, choose from thoughtfully designed one, two, or three-bedroom floor plans that suit your lifestyle. Picture your new home surrounded by community spirit and vibrant living. Curious about life here? Check out resident testimonials and schedule your tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to Linden at Southover in beautiful Savannah, GA! Our diverse floor plans—one, two, and three-bedroom options—are designed to fit your lifestyle. A team member will be in touch soon to help you find your perfect home in our vibrant community. Stay tuned!",
  "property_virtualtours_blurb": "At Linden at Southover in Savannah, GA, our thoughtfully designed apartments offer one, two, and three-bedroom floor plans to suit your lifestyle. Experience the charm of our vibrant community—take a virtual tour and envision your new home adorned with natural light and modern comforts! Your ideal apartment awaits.",
  "property_copyright": "2026 All Rights Reserved. Linden at Southover",
  "property_seo_title_home": "Linden at Southover |  Apartments in Savannah, GA",
  "property_seo_description_home": "Experience luxury living at Linden at Southover in Savannah, GA. Choose from spacious floor plans and enjoy resort-style amenities designed for your lifestyle!",
  "property_seo_title_floorplans": "Floor Plans | Savannah, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Linden at Southover in Savannah, GA. Browse our unique one, two, and three-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Savannah, GA Apartments for Rent",
  "property_seo_description_amenities": "Discover luxurious living at Linden at Southover in Savannah, GA, featuring upscale amenities, stylish apartments, and a vibrant community!",
  "property_seo_title_gallery": "Gallery | Apartments in Savannah, GA",
  "property_seo_description_gallery": "Step into luxury at Linden at Southover in Savannah, GA! With stunning amenities and stylish floor plans, envision your perfect home with us today!",
  "property_seo_title_virtualtours": "Virtual Tours | Linden at Southover Apartments",
  "property_seo_description_virtualtours": "Discover Linden at Southover in Savannah, GA! Take a virtual tour of our spacious 1-3 bedroom apartments and envision your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Linden at Southover Apartments",
  "property_seo_description_interactivemap": "Discover Savannah living at Linden at Southover! Explore our interactive map for one to three-bedroom apartments with resort-style amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Savannah, GA",
  "property_seo_description_neighborhood": "Uncover Savannah's charm at Linden at Southover! Dive into local favorites and nearby gems, all just steps from your one, two, or three-bedroom apartment home.",
  "property_seo_title_contact": "Contact Us | Linden at Southover",
  "property_seo_description_contact": "Connect with Linden at Southover in Savannah! Our leasing team is ready to answer your questions about beautiful one to three-bedroom homes. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Savannah, GA",
  "property_seo_description_faqs": "Your questions answered! Dive into our FAQs to learn about Linden at Southover's unique amenities, floor plans, and community vibe in beautiful Savannah, GA.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Savannah, GA",
  "property_seo_description_reviews": "Join our vibrant community at Linden at Southover! See what residents love about our spacious homes, top-notch amenities, and the charm of Savannah living.",
  "property_seo_title_applynow": "Apply Now | Apartments in Savannah, GA",
  "property_seo_description_applynow": "Discover Linden at Southover in Savannah, GA: spacious floor plans, luxury amenities, and a vibrant community. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Linden at Southover",
  "property_seo_description_residentaccess": "Unlock your Linden at Southover experience! Log in to your resident portal for easy rent payment, quick maintenance requests, and convenient community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Linden at Southover",
  "property_seo_description_referafriend": "Share the joy of living at Linden at Southover! Refer a friend and enjoy vibrant Savannah living together, where great friends become great neighbors.",
  "property_seo_title_scheduletour": "Schedule a Tour | Linden at Southover",
  "property_seo_description_scheduletour": "Step into luxury at Linden at Southover in Savannah, GA. Experience upscale living and vibrant amenities. Schedule your tour today and embrace your new home!",
  "property_seo_title_privacy": "Privacy Policy | Linden at Southover",
  "property_seo_description_privacy": "Your privacy matters at Linden at Southover. Review our policy to see how we protect your information while you enjoy life in beautiful Savannah, GA.",
  "property_seo_title_accessibility": "Website Accessibility | Linden at Southover",
  "property_seo_description_accessibility": "Experience digital inclusivity at Linden at Southover in Savannah, GA. Dive into our commitment to accessibility and discover a welcoming home for everyone.",
  "property_seo_title_sitemap": "Sitemap | Linden at Southover",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Linden at Southover! Check out our sitemap for quick access to everything our vibrant Savannah community has to offer.",
  "property_seo_title_thankyou": "Thank You | Linden at Southover",
  "property_seo_description_thankyou": "Thank you for reaching out to Linden at Southover in Savannah, GA! Our team is excited to connect with you soon about your future home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Savannah, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293570108",
  "amenities": [
    {
      "id": "custom_e040f018-c24c-48da-918d-0d3696afaa47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "24 Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_44617526-860a-421c-9010-3cbbe8d7cff9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "24‑hour Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e582864a-7c7f-4ba6-b225-adcf1e6f8285",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Dedicated Yoga Room with Ballet Barre",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2390a126-97f8-4c4b-b70c-aedbb1adead3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Expert On‑site Maintenance Team",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d0adfb8a-da53-49e1-abcd-0d1459f1485d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Management Team",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_368f7db8-f3e4-48e4-9776-87d7ad520fab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Secure Package Concierge",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d531492-f506-47c4-aea1-0490cde9a292",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Strength Training Zone",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_791c6453-bd1f-409d-9f08-94cb557471a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Stylish Resident Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b013532-6c7c-436d-b41c-9149876dbcf9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Access to Public Transit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0088e18-df15-4962-97b6-7eab1b0c6885",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Private Off‑Street Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_37d9a264-1bac-4380-8f6c-89da904d3227",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Gated Community with Controlled Access",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fc2ba147-2cf6-4895-9113-2146c1a7375a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Sundeck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5623a4d8-c07c-4605-97c8-73981908164d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Fenced Dog Park for Your Furry Friends",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ffe9f16c-fc3d-46a0-99c3-83d598e97a24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Trash Pickup‑ Door to Door",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5364860-ff73-4456-8c12-3ebf7a1881f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Cozy Outdoor Fire Pit*",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0cd4c459-4f30-402d-904d-43cbdb63c807",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor BBQ Grills & Picnic Areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b8a9e4c0-0c0e-4601-a22d-257cfe97bc6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑Style Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6664907e-fa89-4522-8963-b00b2b68d8de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Black GE Kitchen Appliances*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b7aa397-6d2c-48b0-bf8c-6be6a2df73c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Built‑in Microwave*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0f03ac03-ee17-448f-b52c-e78bfbaf87db",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Contemporary Cabinet Hardware*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f7e8cbf4-0690-487d-9c4e-0196bf261ee0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Ice Maker",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4f444a8a-c687-41b5-837e-444f83f26f65",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Custom Cabinet Finishes*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0a7a0352-e3b5-49ab-a589-9e190af14350",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Lighting Fixtures*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1f7e2f90-f458-4620-a3ca-34ef871c87a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6c1ba744-64b0-4a6e-b997-629939ffe924",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Elegant Arched Foyer Entry*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6a896895-49db-4730-850f-a9821e12e89e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_acbbd354-e896-4c4b-8f96-95d9ac2d8156",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Full‑Size In‑Unit Washer & Dryer*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d66e0337-c307-4121-82f6-550410d95be0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "High‑Speed Internet & Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3a85eefe-fce6-4e11-98e6-75838bae1f30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Lofty High Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2fa98a48-17cf-4700-87ee-1dd37176c21b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d30f37a-20e3-4a5e-a60b-689fb1bdf80b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Open Dining Area for Entertaining",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95463acc-a41b-480d-b2c1-38a1d3fa28c4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Plush Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3d1d81b0-052f-4b7f-9a66-84541483dbee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec905a92-024e-411a-9ef8-696628986216",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Safety Sprinkler System",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5fe59a0c-ceff-4c33-84b3-963941b3d2a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Linen Closet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b048c1eb-d0eb-4e78-94e5-e6e6b9af6ee6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Stylish Stainless Steel Appliances*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76fd8637-2073-4e6c-849e-62c2af56679f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Stylish Window Treatments",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8ec5f247-5e61-46f8-87b7-24bcd8ff2d02",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer Connections*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21b348da-a098-4bc6-a4a5-4227056bff0b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑vinyl Plank Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_73719efb-fec4-4390-83de-c1f9af7444b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "external_id": "false",
      "title": "Exterior Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_de94c18f-bb7a-4b26-a1b8-c6ea74234690",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-4c04-754a-aa64-ab6757bffc2b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a modern building.",
        "public_id": "019eae33-4c04-754a-aa64-ab6757bffc2b",
        "storage_key": "property/6767906449167459/019eae33-4c04-754a-aa64-ab6757bffc2b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling swimming pool, complete with comfortable lounge chairs and refreshing umbrellas. Perfect for soaking up the sun or unwinding after a long day.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of a modern building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1aa371b6-ec4c-42c9-901b-30d3d361d41e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/01a0c559-9cf5-72b9-9cce-cefff82817a6.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed, ceiling fan, and closet.",
        "public_id": "01a0c559-9cf5-72b9-9cce-cefff82817a6",
        "storage_key": "property/6767906449167459/01a0c559-9cf5-72b9-9cce-cefff82817a6.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "Spacious primary bedroom featuring a comfortable king-size bed, elegant decor, a modern ceiling fan, and ample closet space for storage.",
      "link": "",
      "alt_text": "Primary bedroom with a king-size bed, ceiling fan, and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ab35f4c1-2774-45b2-b6a4-3e0ac8d4bdf8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/01a0c559-9bcc-7593-84bb-43d818dd2f04.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, subway tile backsplash, stainless steel dishwasher, and a large sink.",
        "public_id": "01a0c559-9bcc-7593-84bb-43d818dd2f04",
        "storage_key": "property/6767906449167459/01a0c559-9bcc-7593-84bb-43d818dd2f04.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, a sleek subway tile backsplash, and a deep sink. Perfect for preparing meals and entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, subway tile backsplash, stainless steel dishwasher, and a large sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_483a38bb-2a6d-4968-b1e4-6134ea838481",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/01a0c559-9d04-730e-8caf-a6e9488bc1da.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and beige and white cabinets.",
        "public_id": "01a0c559-9d04-730e-8caf-a6e9488bc1da",
        "storage_key": "property/6767906449167459/01a0c559-9d04-730e-8caf-a6e9488bc1da.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this modern kitchen featuring stainless steel appliances, ample cabinet space, and a convenient in-unit washer and dryer.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and beige and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_02bbc8e8-662a-4fea-857c-79ab0ebbe0fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/01a0c559-9c32-70bd-aac8-a5b01634cc84.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a single vanity, toilet, and shower.",
        "public_id": "01a0c559-9c32-70bd-aac8-a5b01634cc84",
        "storage_key": "property/6767906449167459/01a0c559-9c32-70bd-aac8-a5b01634cc84.webp",
        "width": 1672,
        "height": 941
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a sleek vanity, modern fixtures, and a clean, inviting atmosphere.",
      "link": "",
      "alt_text": "Modern bathroom with a single vanity, toilet, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a01c0865-4712-4776-afe4-b4336a9b12d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-613c-7111-9115-c08a86bd8628.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and stationary bikes.",
        "public_id": "019eae33-613c-7111-9115-c08a86bd8628",
        "storage_key": "property/6767906449167459/019eae33-613c-7111-9115-c08a86bd8628.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with treadmills, elliptical machines, and stationary bikes to help you achieve your wellness goals.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, and stationary bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9df3ce74-f207-43bb-99ec-b60904c45fb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-4b8e-7241-8a32-f8335ffc6f38.webp",
      "image_media": {
        "alt_text": "Gym equipment including weight racks, dumbbells, kettlebells, medicine balls, and a punching bag.",
        "public_id": "019eae33-4b8e-7241-8a32-f8335ffc6f38",
        "storage_key": "property/6767906449167459/019eae33-4b8e-7241-8a32-f8335ffc6f38.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a full range of equipment for a complete workout, including cardio machines, free weights, and strength training stations.",
      "link": "",
      "alt_text": "Gym equipment including weight racks, dumbbells, kettlebells, medicine balls, and a punching bag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_74c92689-63f4-46f2-b54e-da109665af7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-4cc6-72ab-8d4c-70a1e5734b4e.webp",
      "image_media": {
        "alt_text": "Exterior view of an apartment building with a wheelchair accessible parking sign.",
        "public_id": "019eae33-4cc6-72ab-8d4c-70a1e5734b4e",
        "storage_key": "property/6767906449167459/019eae33-4cc6-72ab-8d4c-70a1e5734b4e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Exterior view of a multi-story apartment building with white siding, teal shutters, and brick accents. A wheelchair accessible parking sign is visible in the foreground.",
      "link": "",
      "alt_text": "Exterior view of an apartment building with a wheelchair accessible parking sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_82d74f56-288e-442c-b2ae-cef149f84fe1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-4957-70e8-8a02-6da33d53967e.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and umbrellas",
        "public_id": "019eae33-4957-70e8-8a02-6da33d53967e",
        "storage_key": "property/6767906449167459/019eae33-4957-70e8-8a02-6da33d53967e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax by our sparkling swimming pool, complete with comfortable lounge chairs and ample shade from umbrellas, offering a perfect escape on a sunny day.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d7cf1091-1f82-48ce-8f86-c55d308dd1a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-5719-720a-a63a-eba15982c6cb.webp",
      "image_media": {
        "alt_text": "Spacious reception area with a curved desk and a logo, overlooking a pool.",
        "public_id": "019eae33-5719-720a-a63a-eba15982c6cb",
        "storage_key": "property/6767906449167459/019eae33-5719-720a-a63a-eba15982c6cb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to our beautifully appointed leasing office and reception area, featuring a stylish curved desk and a view of the resort-style pool.",
      "link": "",
      "alt_text": "Spacious reception area with a curved desk and a logo, overlooking a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a78a66f9-46c0-4a49-82f5-930757ed8352",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-42b9-766e-b135-4823430ad7e3.webp",
      "image_media": {
        "alt_text": "Modern lobby seating area with tropical wallpaper and large glass windows overlooking a pool.",
        "public_id": "019eae33-42b9-766e-b135-4823430ad7e3",
        "storage_key": "property/6767906449167459/019eae33-42b9-766e-b135-4823430ad7e3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating and elegant decor. Enjoy views of the resort-style pool from this welcoming space.",
      "link": "",
      "alt_text": "Modern lobby seating area with tropical wallpaper and large glass windows overlooking a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5667f946-d518-4de9-9808-804aeabf6b8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-3d14-712a-92c8-c2b18612af5b.webp",
      "image_media": {
        "alt_text": "Lounge area with sectional sofa and chairs overlooking a swimming pool.",
        "public_id": "019eae33-3d14-712a-92c8-c2b18612af5b",
        "storage_key": "property/6767906449167459/019eae33-3d14-712a-92c8-c2b18612af5b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our beautifully appointed lounge with stunning views of the resort-style pool, perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Lounge area with sectional sofa and chairs overlooking a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_989503d4-d5ac-4d6c-a1d5-edcaef229fcc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-3855-743d-bf40-84bf414f950d.webp",
      "image_media": {
        "alt_text": "Coffee station with a Keurig coffee maker, tea, and snacks.",
        "public_id": "019eae33-3855-743d-bf40-84bf414f950d",
        "storage_key": "property/6767906449167459/019eae33-3855-743d-bf40-84bf414f950d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee, tea, and snacks at our resident coffee bar.",
      "link": "",
      "alt_text": "Coffee station with a Keurig coffee maker, tea, and snacks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e5bab247-302d-432d-9f77-c249fd2ff107",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-31f8-706d-88ee-8800c7cba835.webp",
      "image_media": {
        "alt_text": "Community coffee bar and seating area",
        "public_id": "019eae33-31f8-706d-88ee-8800c7cba835",
        "storage_key": "property/6767906449167459/019eae33-31f8-706d-88ee-8800c7cba835.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks in our resident lounge area, featuring a fully stocked coffee bar and comfortable seating.",
      "link": "",
      "alt_text": "Community coffee bar and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f340b66d-cd4a-41ce-817a-c0395115dfa9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-2fed-776e-8360-1262b896c5c9.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with white siding and teal shutters, featuring balconies and a parking lot.",
        "public_id": "019eae33-2fed-776e-8360-1262b896c5c9",
        "storage_key": "property/6767906449167459/019eae33-2fed-776e-8360-1262b896c5c9.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover comfortable living in this beautifully maintained apartment building, featuring private balconies and convenient resident parking.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with white siding and teal shutters, featuring balconies and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5bd10063-1bb2-40f5-ae96-d3af7622ba5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-0947-7148-b1c3-8a7c82eb21b1.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with white siding and teal shutters, surrounded by greenery.",
        "public_id": "019eae33-0947-7148-b1c3-8a7c82eb21b1",
        "storage_key": "property/6767906449167459/019eae33-0947-7148-b1c3-8a7c82eb21b1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Exterior view of a multi-story apartment building featuring white siding, teal shutters, and brick accents, set against a backdrop of lush trees and a partly cloudy sky.",
      "link": "",
      "alt_text": "Apartment building exterior with white siding and teal shutters, surrounded by greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5f6dcc48-a5e5-42e5-8e0d-085376a4dbd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-1b6f-7788-b6f9-ccd791cf3536.webp",
      "image_media": {
        "alt_text": "Fitness center gym with punching bag, TRX straps, medicine balls, and kettlebells.",
        "public_id": "019eae33-1b6f-7788-b6f9-ccd791cf3536",
        "storage_key": "property/6767906449167459/019eae33-1b6f-7788-b6f9-ccd791cf3536.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a boxing station, TRX suspension trainers, and a variety of weights and balls.",
      "link": "",
      "alt_text": "Fitness center gym with punching bag, TRX straps, medicine balls, and kettlebells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3da62e35-fdea-4fce-81bc-b0f1a5e65539",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-088d-72ae-bcd9-ec22e6b2d6d4.webp",
      "image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking a swimming pool and trees.",
        "public_id": "019eae33-088d-72ae-bcd9-ec22e6b2d6d4",
        "storage_key": "property/6767906449167459/019eae33-088d-72ae-bcd9-ec22e6b2d6d4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lounge, featuring comfortable seating and stunning views of the outdoor pool area. Perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Indoor lounge area with large windows overlooking a swimming pool and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f0acf9ee-9376-4a77-a327-e7d897dfbe2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-0c45-74be-9fb0-67aa179a50dd.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with weight machines, free weights, and a tire sled.",
        "public_id": "019eae33-0c45-74be-9fb0-67aa179a50dd",
        "storage_key": "property/6767906449167459/019eae33-0c45-74be-9fb0-67aa179a50dd.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide array of weight machines, free weights, cardio equipment, and functional training tools.",
      "link": "",
      "alt_text": "Fully equipped fitness center with weight machines, free weights, and a tire sled.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_55ab9cf9-46af-48d2-9741-6afff37af7d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-02fa-732d-aa3c-8c675de68cf3.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019eae33-02fa-732d-aa3c-8c675de68cf3",
        "storage_key": "property/6767906449167459/019eae33-02fa-732d-aa3c-8c675de68cf3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy our sparkling resort-style swimming pool, complete with comfortable lounge chairs and ample shade from umbrellas. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d82cbef4-51c4-49e9-9fcb-79ec31682447",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae33-1275-714c-a987-467c9d327799.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019eae33-1275-714c-a987-467c9d327799",
        "storage_key": "property/6767906449167459/019eae33-1275-714c-a987-467c9d327799.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush greenery and comfortable lounge seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f516a5a-3cd9-487c-a865-316d643fd948",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-fd3c-774c-adf2-a82fd79872f7.webp",
      "image_media": {
        "alt_text": "Mailroom with rows of mailboxes, modern lighting, and a sleek white counter.",
        "public_id": "019eae32-fd3c-774c-adf2-a82fd79872f7",
        "storage_key": "property/6767906449167459/019eae32-fd3c-774c-adf2-a82fd79872f7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Discover a modern and convenient mailroom, complete with individual mailboxes and a stylish counter area.",
      "link": "",
      "alt_text": "Mailroom with rows of mailboxes, modern lighting, and a sleek white counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aa1dc2fc-c386-49d7-b7b9-50986100896a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-f85e-7098-a07d-157d57f576f1.webp",
      "image_media": {
        "alt_text": "Bright and modern community lounge with a view of the pool.",
        "public_id": "019eae32-f85e-7098-a07d-157d57f576f1",
        "storage_key": "property/6767906449167459/019eae32-f85e-7098-a07d-157d57f576f1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax in the stylish community lounge featuring comfortable seating and large windows overlooking the pool area.",
      "link": "",
      "alt_text": "Bright and modern community lounge with a view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_77250736-240b-47b0-9de2-195f771d9ed6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-eb6e-701d-9637-e7fff6c0f3d4.webp",
      "image_media": {
        "alt_text": "Communal lounge area with seating and large windows overlooking a pool and lush greenery.",
        "public_id": "019eae32-eb6e-701d-9637-e7fff6c0f3d4",
        "storage_key": "property/6767906449167459/019eae32-eb6e-701d-9637-e7fff6c0f3d4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish communal lounge, featuring comfortable seating and stunning views of the resort-style pool and tropical landscaping.",
      "link": "",
      "alt_text": "Communal lounge area with seating and large windows overlooking a pool and lush greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7eb68b80-aede-47a4-ba7d-45461c8fa9cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-e417-76c0-94ab-760414889483.webp",
      "image_media": {
        "alt_text": "Amazon Hub package lockers in a multifamily property hallway.",
        "public_id": "019eae32-e417-76c0-94ab-760414889483",
        "storage_key": "property/6767906449167459/019eae32-e417-76c0-94ab-760414889483.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Secure Amazon Hub package lockers for residents in the property's hallway.",
      "link": "",
      "alt_text": "Amazon Hub package lockers in a multifamily property hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b34aa812-db89-4f3a-84da-1c7e4063f6bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-ca59-714d-a7bf-d5d3f644e662.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel sink.",
        "public_id": "019eae32-ca59-714d-a7bf-d5d3f644e662",
        "storage_key": "property/6767906449167459/019eae32-ca59-714d-a7bf-d5d3f644e662.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Bright and airy kitchen featuring ample cabinet space, elegant granite countertops, and a spacious sink. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_035bbb41-cd68-4cbd-b6d7-26c123c88ec8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-c6dd-7568-be0b-5c15f2703a63.webp",
      "image_media": {
        "alt_text": "Living room with a white armchair, teal cabinet, and artwork.",
        "public_id": "019eae32-c6dd-7568-be0b-5c15f2703a63",
        "storage_key": "property/6767906449167459/019eae32-c6dd-7568-be0b-5c15f2703a63.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living area with comfortable seating, decorative cabinet, and a view of the outdoors.",
      "link": "",
      "alt_text": "Living room with a white armchair, teal cabinet, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f275f98d-0a58-469d-a846-ea3de8799664",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-c734-7034-a12f-2164561b25c6.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, black appliances, and a doorway leading to a laundry area.",
        "public_id": "019eae32-c734-7034-a12f-2164561b25c6",
        "storage_key": "property/6767906449167459/019eae32-c734-7034-a12f-2164561b25c6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A modern and functional kitchen featuring sleek white cabinetry, durable granite countertops, and essential black appliances, perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, granite countertops, black appliances, and a doorway leading to a laundry area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_01f56f96-c696-4ef9-9c1a-c6bba88e5b9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-c3bb-7610-ae7f-c1277874af4b.webp",
      "image_media": {
        "alt_text": "Living room and dining area with modern furnishings and decor.",
        "public_id": "019eae32-c3bb-7610-ae7f-c1277874af4b",
        "storage_key": "property/6767906449167459/019eae32-c3bb-7610-ae7f-c1277874af4b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed living and dining area, featuring contemporary furniture, elegant artwork, and a warm, inviting ambiance.",
      "link": "",
      "alt_text": "Living room and dining area with modern furnishings and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4d502fb1-c3c8-4a2c-a6e7-92dcecc15afd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-d863-707f-8b32-c1a7e550a010.webp",
      "image_media": {
        "alt_text": "Living room with a tan sofa, armchair, large rug, and double glass doors leading outside.",
        "public_id": "019eae32-d863-707f-8b32-c1a7e550a010",
        "storage_key": "property/6767906449167459/019eae32-d863-707f-8b32-c1a7e550a010.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush tan sofa and comfortable armchair, perfect for relaxing. Large glass doors open to a scenic view, filling the space with natural light.",
      "link": "",
      "alt_text": "Living room with a tan sofa, armchair, large rug, and double glass doors leading outside.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_33f5762d-0d52-4acf-9a27-09f5ae42100d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-d857-75fe-ad45-4ac26eb980f7.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with black refrigerator, white cabinets, and granite countertops.",
        "public_id": "019eae32-d857-75fe-ad45-4ac26eb980f7",
        "storage_key": "property/6767906449167459/019eae32-d857-75fe-ad45-4ac26eb980f7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy meals in the dining area and prepare food in the modern kitchen, featuring a black refrigerator, white cabinets, and granite countertops.",
      "link": "",
      "alt_text": "Dining area and kitchen with black refrigerator, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_97bb3aec-f4ea-4f65-884c-5e3092b9a39e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-d847-773e-81e8-3818d2f445e8.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a granite countertop, white vanity, toilet, and bathtub with a striped shower curtain.",
        "public_id": "019eae32-d847-773e-81e8-3818d2f445e8",
        "storage_key": "property/6767906449167459/019eae32-d847-773e-81e8-3818d2f445e8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Freshen up in this sleek, modern bathroom, complete with a spacious vanity, granite countertops, and a relaxing bathtub.",
      "link": "",
      "alt_text": "Modern bathroom with a granite countertop, white vanity, toilet, and bathtub with a striped shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13fec890-a339-4043-87a8-19b81008183b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-c8a8-744c-80ef-4daa57851955.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, bedside tables, and decorative accents.",
        "public_id": "019eae32-c8a8-744c-80ef-4daa57851955",
        "storage_key": "property/6767906449167459/019eae32-c8a8-744c-80ef-4daa57851955.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this beautifully appointed bedroom. Featuring a plush king-size bed, elegant bedside tables, and tasteful decor, it's the perfect retreat.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-size bed, bedside tables, and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9aa5a576-189d-407a-a2d2-907ab6a9eaa7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-c1ee-74ec-997b-6d0af0f7fb7b.webp",
      "image_media": {
        "alt_text": "Washer and dryer set in laundry closet with wire shelving and wood-look flooring.",
        "public_id": "019eae32-c1ee-74ec-997b-6d0af0f7fb7b",
        "storage_key": "property/6767906449167459/019eae32-c1ee-74ec-997b-6d0af0f7fb7b.webp",
        "width": 2049,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer, complete with shelving for all your laundry needs.",
      "link": "",
      "alt_text": "Washer and dryer set in laundry closet with wire shelving and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7f3b5a1b-b8c7-4ab5-b9e7-3c95c8c71e03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-a265-7658-ac3f-278625e3139e.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding green space.",
        "public_id": "019eae32-a265-7658-ac3f-278625e3139e",
        "storage_key": "property/6767906449167459/019eae32-a265-7658-ac3f-278625e3139e.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Aerial view showcasing the apartment complex nestled within lush greenery and trees, highlighting the community's serene environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and surrounding green space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0fb0b57c-2e18-4fd1-b058-4d898f4f8849",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-9e3c-765d-8332-e68d3ce5d9e6.webp",
      "image_media": {
        "alt_text": "Aerial view of a large, sparkling blue swimming pool with teal umbrellas and lounge chairs surrounding it. A modern clubhouse is visible in the background.",
        "public_id": "019eae32-9e3c-765d-8332-e68d3ce5d9e6",
        "storage_key": "property/6767906449167459/019eae32-9e3c-765d-8332-e68d3ce5d9e6.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with ample lounge seating and shaded umbrellas. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Aerial view of a large, sparkling blue swimming pool with teal umbrellas and lounge chairs surrounding it. A modern clubhouse is visible in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_37608f17-d7f8-4706-9bd2-3d23a1b8fb75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-a0fc-722a-9cf5-cf700d6c5419.webp",
      "image_media": {
        "alt_text": "Luxury outdoor swimming pool with lounge chairs and umbrellas next to a white building.",
        "public_id": "019eae32-a0fc-722a-9cf5-cf700d6c5419",
        "storage_key": "property/6767906449167459/019eae32-a0fc-722a-9cf5-cf700d6c5419.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and refreshing umbrellas. Adjacent to the community building, it's the perfect spot to unwind.",
      "link": "",
      "alt_text": "Luxury outdoor swimming pool with lounge chairs and umbrellas next to a white building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d6ec783-f11d-4292-9bfb-1ad007749754",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-9ca4-716a-8feb-cbf6b64de93b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019eae32-9ca4-716a-8feb-cbf6b64de93b",
        "storage_key": "property/6767906449167459/019eae32-9ca4-716a-8feb-cbf6b64de93b.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable seating.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9a1b19a3-bce2-4604-8ac1-8747ee472e90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-923d-72de-ab06-89e69b1d1534.webp",
      "image_media": {
        "alt_text": "An outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019eae32-923d-72de-ab06-89e69b1d1534",
        "storage_key": "property/6767906449167459/019eae32-923d-72de-ab06-89e69b1d1534.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "",
      "alt_text": "An outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e147803-06d9-4cc2-9e06-d1f7f72f03e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-9298-7478-ac93-7d60b3735b00.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and clubhouse at a multifamily property",
        "public_id": "019eae32-9298-7478-ac93-7d60b3735b00",
        "storage_key": "property/6767906449167459/019eae32-9298-7478-ac93-7d60b3735b00.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, or gather with friends at the modern clubhouse. This community offers resort-style amenities for your enjoyment.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool and clubhouse at a multifamily property",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f49679c3-1418-4f23-9636-c750e99bb5d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-7231-703a-9e7f-7cd5dff17119.webp",
      "image_media": {
        "alt_text": "Exterior of a multi-story apartment building with balconies and teal shutters.",
        "public_id": "019eae32-7231-703a-9e7f-7cd5dff17119",
        "storage_key": "property/6767906449167459/019eae32-7231-703a-9e7f-7cd5dff17119.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Exterior view of a multi-level apartment complex showcasing its architecture, balconies, and landscaping under a partly cloudy sky.",
      "link": "",
      "alt_text": "Exterior of a multi-story apartment building with balconies and teal shutters.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4daa6513-7017-48c7-8a19-d2267e32679d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-709d-7104-8e9d-13d0b4c6343b.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and teal umbrellas.",
        "public_id": "019eae32-709d-7104-8e9d-13d0b4c6343b",
        "storage_key": "property/6767906449167459/019eae32-709d-7104-8e9d-13d0b4c6343b.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning swimming pool, surrounded by comfortable lounge chairs and vibrant teal umbrellas. An oasis of tranquility awaits you.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and teal umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99ffc9a6-df15-4903-893c-12e8fb7dc0e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-7166-723f-930d-739c48f87cd0.webp",
      "image_media": {
        "alt_text": "Modern clubhouse with a metal roof and teal shutters, featuring a parking lot with a golf cart and cars.",
        "public_id": "019eae32-7166-723f-930d-739c48f87cd0",
        "storage_key": "property/6767906449167459/019eae32-7166-723f-930d-739c48f87cd0.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover our stunning clubhouse, a central hub for residents, featuring modern architecture, ample parking, and a welcoming entrance.",
      "link": "",
      "alt_text": "Modern clubhouse with a metal roof and teal shutters, featuring a parking lot with a golf cart and cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_adafe71c-947d-4b6a-be12-b500c8e40cf8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-6691-7728-b25e-6be8f35fbbd6.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and parking lots surrounded by trees.",
        "public_id": "019eae32-6691-7728-b25e-6be8f35fbbd6",
        "storage_key": "property/6767906449167459/019eae32-6691-7728-b25e-6be8f35fbbd6.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Spacious apartment community with ample parking and lush green surroundings.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and parking lots surrounded by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a829145-6bc1-454f-b1d0-5ec00aae97be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-5f47-7728-b691-f14a56251a32.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to a modern building.",
        "public_id": "019eae32-5f47-7728-b691-f14a56251a32",
        "storage_key": "property/6767906449167459/019eae32-5f47-7728-b691-f14a56251a32.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax by our resort-style swimming pool, complete with comfortable lounge chairs and shaded umbrellas, adjacent to our modern clubhouse.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas next to a modern building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ffd4e36-3b12-439c-873f-abc50bb96072",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-623a-730b-a42f-5114119d95a0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas next to a building.",
        "public_id": "019eae32-623a-730b-a42f-5114119d95a0",
        "storage_key": "property/6767906449167459/019eae32-623a-730b-a42f-5114119d95a0.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax by the resort-style pool, featuring comfortable lounge chairs and shaded cabanas for a perfect day in the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and umbrellas next to a building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2efcd55b-9098-435d-a94c-265c614c12e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019eae32-5dff-746e-a09b-102f3cd2829c.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas next to a modern clubhouse.",
        "public_id": "019eae32-5dff-746e-a09b-102f3cd2829c",
        "storage_key": "property/6767906449167459/019eae32-5dff-746e-a09b-102f3cd2829c.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax by the sparkling resort-style swimming pool, complete with comfortable lounge chairs and refreshing umbrellas. Adjacent to our modern clubhouse, it's the perfect spot for unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas next to a modern clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e3d06d3b-e508-4613-a996-fc7b81daba86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019faa39-d6ee-7268-b3cc-6c9a231edacb.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and umbrellas in a green, treelined courtyard.",
        "public_id": "019faa39-d6ee-7268-b3cc-6c9a231edacb",
        "storage_key": "property/6767906449167459/019faa39-d6ee-7268-b3cc-6c9a231edacb.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling swimming pool, surrounded by lush greenery and comfortable lounge seating.",
      "link": "",
      "alt_text": "Luxury swimming pool with lounge chairs and umbrellas in a green, treelined courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39247e83-ad47-44a7-8216-7327df999934",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019faa39-d5b3-701d-ae35-a2ba1faa9d1a.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and teal umbrellas.",
        "public_id": "019faa39-d5b3-701d-ae35-a2ba1faa9d1a",
        "storage_key": "property/6767906449167459/019faa39-d5b3-701d-ae35-a2ba1faa9d1a.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and shaded areas perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and teal umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a539bfe-d57c-44f9-9810-1b839a7bf7b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019faa39-d53b-77a7-91ef-02063ae570ce.webp",
      "image_media": {
        "alt_text": "Poolside lounge chairs and umbrellas with palm trees and lush greenery.",
        "public_id": "019faa39-d53b-77a7-91ef-02063ae570ce",
        "storage_key": "property/6767906449167459/019faa39-d53b-77a7-91ef-02063ae570ce.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Community",
      "description": "Relax by the sparkling pool, surrounded by palm trees and comfortable lounge chairs. Your oasis awaits!",
      "link": "",
      "alt_text": "Poolside lounge chairs and umbrellas with palm trees and lush greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_48d2ebf5-0864-4d1e-ba06-fb1d1154f7a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Coffee Deli",
      "poi_type": "Restaurants",
      "poi_address": "4517 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "Relaxed coffee shop set inside the Habersham Shopping Center in Midtown's Lamara Heights neighborhood.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-09a2-7651-8e98-22a32cf4683d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-09a2-7651-8e98-22a32cf4683d",
        "storage_key": "property/6767906449167459/019dfe3b-09a2-7651-8e98-22a32cf4683d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.savannahcoffeedeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7627458430010409658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coffee-deli",
      "poi_latitude": "32.036266",
      "poi_longitude": "-81.10305029999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-352-7818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-6630-72cc-b12e-f646ee0fc910.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe3b-6630-72cc-b12e-f646ee0fc910",
        "storage_key": "property/6767906449167459/019dfe3b-6630-72cc-b12e-f646ee0fc910.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJd9JFIIx1-4gRukLUswct2mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_994b432a-4090-457e-9a76-ff0402daba64",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Bandana Burger",
      "poi_type": "Restaurants",
      "poi_address": "4525 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "Casual eatery turning out burgers, wings and fries (including vegan options).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-06f1-7294-88e2-dab33ae44fee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-06f1-7294-88e2-dab33ae44fee",
        "storage_key": "property/6767906449167459/019dfe3b-06f1-7294-88e2-dab33ae44fee.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.bandanaburger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3633372562924241765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bandana-burger",
      "poi_latitude": "32.0360788",
      "poi_longitude": "-81.1032836",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-468-8007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e9-7343-89fc-d035d31e21d1",
        "storage_key": "property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9b-3O2f-4gRZQPAdRhVbDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d507cacc-8c0d-478f-989d-9fe2102a6168",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Midtown Sports Grill",
      "poi_type": "Restaurants",
      "poi_address": "4521 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "Relaxed restaurant and bar with a casual atmosphere, live entertainment, and TV sports.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-0c67-71cf-a903-89c099dabf76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-0c67-71cf-a903-89c099dabf76",
        "storage_key": "property/6767906449167459/019dfe3b-0c67-71cf-a903-89c099dabf76.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.midtownsportsgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11226552452442129304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midtown-sports-grill",
      "poi_latitude": "32.0361859",
      "poi_longitude": "-81.1032404",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-349-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e9-7343-89fc-d035d31e21d1",
        "storage_key": "property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO0Klvoh1-4gRmIMahPm5zJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_56a79dee-884d-438f-ab3d-30b4f5407543",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Colleagues & Lovers",
      "poi_type": "Restaurants",
      "poi_address": "4523 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-0940-70af-ba4f-0af7e2681458.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-0940-70af-ba4f-0af7e2681458",
        "storage_key": "property/6767906449167459/019dfe3b-0940-70af-ba4f-0af7e2681458.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.colleaguesandlovers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9955173813533710510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colleagues--lovers",
      "poi_latitude": "32.0361316",
      "poi_longitude": "-81.1032512",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-999-6582",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e9-7343-89fc-d035d31e21d1",
        "storage_key": "property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCYhFVNp1-4gRrpjysNbhJ4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b6f208d5-f7a7-49a6-8e29-a5f8a2e8510f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "The 5 Spot Midtown - Neighborhood Kitchen and Bar",
      "poi_type": "Restaurants",
      "poi_address": "4430 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "Neighborhood eatery offering easygoing American bites like fried green tomatoes, burgers & fried chicken, plus happy hours.",
      "poi_long_description": "Neighborhood eatery offering easygoing American bites like fried green tomatoes, burgers & fried chicken, plus happy hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-0a91-72bd-b588-9941a4cd7765.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-0a91-72bd-b588-9941a4cd7765",
        "storage_key": "property/6767906449167459/019dfe3b-0a91-72bd-b588-9941a4cd7765.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://5spotmidtown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15143125938885346583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-5-spot-midtown---neighborhood-kitchen-and-bar",
      "poi_latitude": "32.0369735",
      "poi_longitude": "-81.1024068",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-777-3021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e9-7343-89fc-d035d31e21d1",
        "storage_key": "property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnWRGBYx1-4gRF8VDSM8wJ9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4445b778-9485-4257-a5b8-b4c0c1bf0530",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Hirano's",
      "poi_type": "Restaurants",
      "poi_address": "4426 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "Informal operation turning out Japanese dishes cooked on teppanyaki grills, plus specialty sushi.",
      "poi_long_description": "Informal operation turning out Japanese dishes cooked on teppanyaki grills, plus specialty sushi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-0681-771b-9d93-0d562ce3d0cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-0681-771b-9d93-0d562ce3d0cf",
        "storage_key": "property/6767906449167459/019dfe3b-0681-771b-9d93-0d562ce3d0cf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://hiranoshabersham.com/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1758341365139208488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hiranos",
      "poi_latitude": "32.0371075",
      "poi_longitude": "-81.1024107",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-353-8337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e9-7343-89fc-d035d31e21d1",
        "storage_key": "property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl3fkB4x1-4gRKHn_zifiZhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_3ff7ec58-d194-449d-881f-4a939d913d44",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Bella's Italian Cafe",
      "poi_type": "Restaurants",
      "poi_address": "4420 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "Extensive Italian menu (from pizza to scampi) in a casual, family-run setting with a long wine list.",
      "poi_long_description": "Extensive Italian menu (from pizza to scampi) in a casual, family-run setting with a long wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-069d-77c8-9c87-8efa8cac08e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-069d-77c8-9c87-8efa8cac08e6",
        "storage_key": "property/6767906449167459/019dfe3b-069d-77c8-9c87-8efa8cac08e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bellascafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11676719718397002262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellas-italian-cafe",
      "poi_latitude": "32.0372572",
      "poi_longitude": "-81.1023721",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-354-4005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e9-7343-89fc-d035d31e21d1",
        "storage_key": "property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSSdYD4x1-4gRFkLazLcKDKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_ae7dffe7-a667-4de0-afda-e4477086ea6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Shuk",
      "poi_type": "Restaurants",
      "poi_address": "1313 Habersham St, Savannah, GA 31401, USA",
      "poi_short_description": "Casual eatery serving Mediterranean fare (including Israeli classics), plus wine and beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJobP1OCuf-4gRLG38hH-AdNs/photos/Ab43m-uannTcYF_AsMdS6jcbfO1UlWvc6Wh070tkKH1V0qzO1MX8OUodD5RrSLlKlkUzX0-sozAJDjb_bJpWxbnRApvgFSgj36p5N2eZagc99G9--X2A52aK3SsdZgoSUUaRReuGbPcVt-quDgOYUKiv-_rHVesFU5xDsBrKgoNM-VGdYY7bsoFmwL3vdb6N0iDT1KAx2bPiQw20hYgqrb1gU1J6m5JnGV5JwE2DMNLbG_XuFzXBXviS_CASuu-sL1DXKgWoZWPwVhcwnc7FskHDgVzKKuf1YCkUTfxz0PLPRG2YfQ/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4734&maxHeightPx=4734",
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.shuksavannah.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15813405476784991532&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shuk",
      "poi_latitude": "32.0616489",
      "poi_longitude": "-81.0939061",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-999-6571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e9-7343-89fc-d035d31e21d1",
        "storage_key": "property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJobP1OCuf-4gRLG38hH-AdNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7b04e2dc-0d2b-487d-8bb0-32ceca6fd23f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Foxy Loxy Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1919 Bull St, Savannah, GA 31401, USA",
      "poi_short_description": "Stylish coffee shop with a menu of Tex-Mex fare, beer & wine, plus art displays & outdoor seating.",
      "poi_long_description": "Stylish coffee shop with a menu of Tex-Mex fare, beer & wine, plus art displays & outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-05f3-7324-9ffd-34ebc9e25893.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-05f3-7324-9ffd-34ebc9e25893",
        "storage_key": "property/6767906449167459/019dfe3b-05f3-7324-9ffd-34ebc9e25893.webp",
        "width": 1280,
        "height": 542
      },
      "poi_business_url": "https://www.foxyloxycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11390000424011381902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foxy-loxy-cafe",
      "poi_latitude": "32.058364",
      "poi_longitude": "-81.099987",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-401-0543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-6630-72cc-b12e-f646ee0fc910.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe3b-6630-72cc-b12e-f646ee0fc910",
        "storage_key": "property/6767906449167459/019dfe3b-6630-72cc-b12e-f646ee0fc910.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJjUC6CLuf-4gRjjy_8AlpEZ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_1a8de2f9-0976-4a6a-82c6-a8208304f0c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Cotton & Rye",
      "poi_type": "Restaurants",
      "poi_address": "1801 Habersham St, Savannah, GA 31401, USA",
      "poi_short_description": "Creative New American gastropub fare, plus an all-American bar, in a former 1950s bank with a deck.",
      "poi_long_description": "Creative New American gastropub fare, plus an all-American bar, in a former 1950s bank with a deck.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-059a-74fb-9fab-ad696ce8c465.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-059a-74fb-9fab-ad696ce8c465",
        "storage_key": "property/6767906449167459/019dfe3b-059a-74fb-9fab-ad696ce8c465.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://cottonandrye.com/about-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=10147447328966605184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cotton--rye",
      "poi_latitude": "32.0583553",
      "poi_longitude": "-81.0949936",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-777-6286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e9-7343-89fc-d035d31e21d1",
        "storage_key": "property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEYh0Xhae-4gRgHkKDJX50ow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_59b9c74f-16a5-4528-99a1-9b1e7ef902d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "PERC",
      "poi_type": "Restaurants",
      "poi_address": "1802 E Broad St, Savannah, GA 31401, USA",
      "poi_short_description": "Spacious roaster & cafe with an industrial-chic vibe offering house-roasted craft coffee & pastries.",
      "poi_long_description": "Spacious roaster & cafe with an industrial-chic vibe offering house-roasted craft coffee & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-0fa3-7608-8c2c-cd8507e4fbd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-0fa3-7608-8c2c-cd8507e4fbd8",
        "storage_key": "property/6767906449167459/019dfe3b-0fa3-7608-8c2c-cd8507e4fbd8.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://perccoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2190982836940177227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perc",
      "poi_latitude": "32.0575513",
      "poi_longitude": "-81.0918308",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-209-0025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-6630-72cc-b12e-f646ee0fc910.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe3b-6630-72cc-b12e-f646ee0fc910",
        "storage_key": "property/6767906449167459/019dfe3b-6630-72cc-b12e-f646ee0fc910.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJc7QmtTye-4gRS__LKEjvZx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_9b72765e-43d8-4f97-a2d8-475fc5dc8063",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "The Grey",
      "poi_type": "Restaurants",
      "poi_address": "109 Martin Luther King Jr Blvd, Savannah, GA 31401, USA",
      "poi_short_description": "Upscale restaurant serving Southern fare and small plates in a historic setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1081-72b8-8ad2-30b5f4a35d88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1081-72b8-8ad2-30b5f4a35d88",
        "storage_key": "property/6767906449167459/019dfe3b-1081-72b8-8ad2-30b5f4a35d88.webp",
        "width": 1280,
        "height": 974
      },
      "poi_business_url": "http://www.thegreyrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=509463294849771541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-grey",
      "poi_latitude": "32.0798625",
      "poi_longitude": "-81.0976641",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-662-5999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e9-7343-89fc-d035d31e21d1",
        "storage_key": "property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRtZgV2e-4gRFeie2yr6EQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ea4efb94-3ad7-4217-9f50-1f6b2442305c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Clary's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "404 Abercorn St, Savannah, GA 31401, USA",
      "poi_short_description": "Perennial place with Southern-style diner classics for breakfast & lunch in a humble atmosphere.",
      "poi_long_description": "Perennial place with Southern-style diner classics for breakfast & lunch in a humble atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-0f44-716f-a2d2-428ca1ac4356.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-0f44-716f-a2d2-428ca1ac4356",
        "storage_key": "property/6767906449167459/019dfe3b-0f44-716f-a2d2-428ca1ac4356.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.claryscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4379828345947752886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarys-cafe",
      "poi_latitude": "32.0716454",
      "poi_longitude": "-81.09203790000001",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-233-0402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e9-7343-89fc-d035d31e21d1",
        "storage_key": "property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa7rPTGme-4gRtgln4axGyDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_a691256b-633d-4be7-899d-438d4547b74e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Leopold's Ice Cream",
      "poi_type": "Restaurants",
      "poi_address": "212 E Broughton St, Savannah, GA 31401, USA",
      "poi_short_description": "Popular ice cream parlor with a marble soda fountain, regular & seasonal flavors, soup & sandwiches.",
      "poi_long_description": "Popular ice cream parlor with a marble soda fountain, regular & seasonal flavors, soup & sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-150a-711d-80e9-ac6456d4e5f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-150a-711d-80e9-ac6456d4e5f6",
        "storage_key": "property/6767906449167459/019dfe3b-150a-711d-80e9-ac6456d4e5f6.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://www.leopoldsicecream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7322773152663827439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leopolds-ice-cream",
      "poi_latitude": "32.0784884",
      "poi_longitude": "-81.08928139999999",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-234-4442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e9-7343-89fc-d035d31e21d1",
        "storage_key": "property/6767906449167459/019dfe37-b8e9-7343-89fc-d035d31e21d1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW9AUqGWe-4gR73NLd2K3n2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_b66f4b91-aa7a-4d0e-bd36-41730b5ba281",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Chu's Mart #119",
      "poi_type": "Shopping & Retail",
      "poi_address": "2 W Derenne Ave, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1180-77d1-a56e-ae2640002dbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1180-77d1-a56e-ae2640002dbd",
        "storage_key": "property/6767906449167459/019dfe3b-1180-77d1-a56e-ae2640002dbd.webp",
        "width": 350,
        "height": 280
      },
      "poi_business_url": "http://www.chusmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13743937764465119624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chus-mart-119",
      "poi_latitude": "32.0293038",
      "poi_longitude": "-81.11133300000002",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-354-7338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-663b-708d-8b3a-3e5d68c35375.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe3b-663b-708d-8b3a-3e5d68c35375",
        "storage_key": "property/6767906449167459/019dfe3b-663b-708d-8b3a-3e5d68c35375.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJw7ubU5p1-4gRiBEFCpRGvL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_0df0294e-dfc9-4049-baa0-6a75201967b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "60 E Derenne Ave, Savannah, GA 31405, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-117a-717a-81b8-ca6dc1692bd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-117a-717a-81b8-ca6dc1692bd7",
        "storage_key": "property/6767906449167459/019dfe3b-117a-717a-81b8-ca6dc1692bd7.webp",
        "width": 1280,
        "height": 1054
      },
      "poi_business_url": "https://locations.familydollar.com/ga/savannah/60-e-derenne-ave?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3906028280567443265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "32.0290198",
      "poi_longitude": "-81.1088231",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-200-8025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-78546d3f4694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-78546d3f4694",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-78546d3f4694.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5xwXxuB1-4gRQS_asQYANTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_9b5f004d-da03-4fdc-b676-f6306bc81743",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "5401 Abercorn St, Savannah, GA 31405, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1296-7378-ac3a-7a75adedd024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1296-7378-ac3a-7a75adedd024",
        "storage_key": "property/6767906449167459/019dfe3b-1296-7378-ac3a-7a75adedd024.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/savannah-ga-pharmacies/5401-abercorn-st-corner-of-derenne-ave-savannah-ga-31405/storeid=5520?WT.mc_id=LS_GOOGLE_FS_5520",
      "poi_directions_map_url": "https://maps.google.com/?cid=18098261100351240970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "32.02804",
      "poi_longitude": "-81.109127",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-356-3170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT48Zv-t1-4gRCru0ApXwKfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_542ac200-406b-408a-aae0-3885da353ae3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "2208 E Derenne Ave, Savannah, GA 31406, USA",
      "poi_short_description": "Chain grocery store offering bulk foods, organic items, and prepared eats, plus a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1496-742f-a70b-f25d16c0b606.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1496-742f-a70b-f25d16c0b606",
        "storage_key": "property/6767906449167459/019dfe3b-1496-742f-a70b-f25d16c0b606.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.foodlion.com/ga/savannah/2208-e-derenne-ave?y_source=1_NTA0Njg2Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10089309951936465640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "32.0194043",
      "poi_longitude": "-81.073021",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-356-1274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b0-704a-b596-df930c750dd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b0-704a-b596-df930c750dd2",
        "storage_key": "property/6767906449167459/019dfe37-b8b0-704a-b596-df930c750dd2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9MduAp2-4gR6Ir8IfJtBIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_11eed090-4a02-47f9-aaf5-c6f992f6ab38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Enson Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "5501 Abercorn St, Savannah, GA 31405, USA",
      "poi_short_description": "Grocery stocking produce, seafood and meats alongside Asian goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dab2f-380d-76c8-a684-fb9593311688.webp",
      "poi_featured_image_media": {
        "alt_text": "Bobo Cafe counter with pastries and bubble tea displays, kiosks for ordering.",
        "public_id": "019dab2f-380d-76c8-a684-fb9593311688",
        "storage_key": "property/6767906449167459/019dab2f-380d-76c8-a684-fb9593311688.webp",
        "width": 2992,
        "height": 2992
      },
      "poi_business_url": "https://ensonmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7855261888996385765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enson-market",
      "poi_latitude": "32.0268437",
      "poi_longitude": "-81.10985339999999",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-206-6118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b0-704a-b596-df930c750dd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b0-704a-b596-df930c750dd2",
        "storage_key": "property/6767906449167459/019dfe37-b8b0-704a-b596-df930c750dd2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW4OBhEx1-4gR5SNLrxF_A20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_7f07ee87-7ed0-4996-918d-288781b4a8b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "3005 Ogeechee Rd, Savannah, GA 31405, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1427-74e9-afef-df13b6340deb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1427-74e9-afef-df13b6340deb",
        "storage_key": "property/6767906449167459/019dfe3b-1427-74e9-afef-df13b6340deb.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ga/savannah/15520",
      "poi_directions_map_url": "https://maps.google.com/?cid=11491312097165511040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "32.0567411",
      "poi_longitude": "-81.1311131",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-226-6116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-78546d3f4694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-78546d3f4694",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-78546d3f4694.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMfIYU8Wf-4gRgAmzAnhXeZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_10daba82-1dae-4b4e-99ba-1b0738587dbb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "318 Mall Blvd Suite 100, Savannah, GA 31406, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-14a6-712d-8604-c707cff391ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-14a6-712d-8604-c707cff391ea",
        "storage_key": "property/6767906449167459/019dfe3b-14a6-712d-8604-c707cff391ea.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/savannah/savannah-marketwalk/011/00697?cid=loc_01100697_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=15465656371393964293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "32.0063117",
      "poi_longitude": "-81.112933",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-200-9158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b0-704a-b596-df930c750dd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b0-704a-b596-df930c750dd2",
        "storage_key": "property/6767906449167459/019dfe37-b8b0-704a-b596-df930c750dd2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6V7_EKx1-4gRBakxe4cModY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0e1001c2-1841-431b-9753-2a5cc1a25fee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Ogeechee Meat Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6011 Ogeechee Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Fresh, clean store dishing up packages of steaks, burgers, sausages, rib-eyes and other meats and seafood for grilling and cooking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-16c6-753f-98d6-03866c8140c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-16c6-753f-98d6-03866c8140c0",
        "storage_key": "property/6767906449167459/019dfe3b-16c6-753f-98d6-03866c8140c0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ogeecheemeatmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13759776945184427771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ogeechee-meat-market",
      "poi_latitude": "31.9967603",
      "poi_longitude": "-81.26080689999999",
      "poi_miles_from_property": "18.7",
      "poi_walking_minutes": "6 hours 52 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-961-5223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-78546d3f4694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-78546d3f4694",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-78546d3f4694.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA7gbFGUJ-4gR-85TrjqM9L4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "butcher_shop"
    },
    {
      "id": "custom_2da99c64-a66b-4378-bf7a-7d2b7104bc5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Haven Elementary School",
      "poi_type": "Education",
      "poi_address": "5111 Dillon Ave, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://spwww.sccpss.com/schools/haven",
      "poi_directions_map_url": "https://maps.google.com/?cid=8051126871334755088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "haven-elementary-school",
      "poi_latitude": "32.034324",
      "poi_longitude": "-81.12410299999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 912-395-6501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOeNjrHl1-4gREJuClztZu28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0624c5e6-de06-47e2-a292-9703936ea4e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "DeRenne Middle School",
      "poi_type": "Education",
      "poi_address": "1009 Clinch St, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://spwww.sccpss.com/schools/dms/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=8263418038592363235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "derenne-middle-school",
      "poi_latitude": "32.0457715",
      "poi_longitude": "-81.1181588",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 912-395-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1QoUxyqe-4gR41ratOyOrXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8cddeee5-f295-40e4-a7dc-2955d5a3468e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Savannah Arts Academy",
      "poi_type": "Education",
      "poi_address": "500 Washington Ave, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1595-7372-87da-024e0f94fe23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1595-7372-87da-024e0f94fe23",
        "storage_key": "property/6767906449167459/019dfe3b-1595-7372-87da-024e0f94fe23.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://saa.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15999445902450454234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-arts-academy",
      "poi_latitude": "32.0460386",
      "poi_longitude": "-81.0928477",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-395-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS9d4gR6e-4gR2m6jkkdzCd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_7e96d84c-ae3f-4f0c-8507-03ddbf3c3082",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Jacob G. Smith Elementary School",
      "poi_type": "Education",
      "poi_address": "210 Lamara Dr, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://jgsmith.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5763647690796515271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jacob-g-smith-elementary-school",
      "poi_latitude": "32.036422",
      "poi_longitude": "-81.1007209",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-395-6530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXdh5iox1-4gRxz9tpAmX_E8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a18cac94-4a1c-414c-8dcd-08dfd7c855ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Mercer Middle School",
      "poi_type": "Education",
      "poi_address": "100 Priscilla D Thomas Way, Garden City, GA 31408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://spwww.sccpss.com/schools/mercer/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3645530830226602156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercer-middle-school",
      "poi_latitude": "32.1071272",
      "poi_longitude": "-81.15770499999999",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-395-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-zSvnGt1-4gRrDhkqfmGlzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b5e92b92-5169-4e7c-b6cf-becce1cde6e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Alfred E. Beach High School",
      "poi_type": "Education",
      "poi_address": "3001 Hopkins St, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-16a6-708a-9ad1-d356f262d419.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-16a6-708a-9ad1-d356f262d419",
        "storage_key": "property/6767906449167459/019dfe3b-16a6-708a-9ad1-d356f262d419.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://beach.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14056084883453317159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alfred-e-beach-high-school",
      "poi_latitude": "32.0549891",
      "poi_longitude": "-81.1161829",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-395-5330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAZN9uC2e-4gRJxD5qro-EcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c0bbea7f-fbf9-41d9-9817-cb3a45504757",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Avant Learning Academy",
      "poi_type": "Education",
      "poi_address": "1728 Staley Ave, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-193b-7507-9064-0f577f978029.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-193b-7507-9064-0f577f978029",
        "storage_key": "property/6767906449167459/019dfe3b-193b-7507-9064-0f577f978029.webp",
        "width": 1280,
        "height": 542
      },
      "poi_business_url": "http://avantlearningacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16312181102404507308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avant-learning-academy",
      "poi_latitude": "32.0403883",
      "poi_longitude": "-81.1388711",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-233-5868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ68nUE_h1-4gRrBapeEmCYOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_b0b47ab3-3ac1-4741-91e9-063ddcf45aae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Urban Christian Academy",
      "poi_type": "Education",
      "poi_address": "4560 Acl Blvd, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1762-7539-9bd0-7db39b1f50e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1762-7539-9bd0-7db39b1f50e7",
        "storage_key": "property/6767906449167459/019dfe3b-1762-7539-9bd0-7db39b1f50e7.webp",
        "width": 768,
        "height": 1024
      },
      "poi_business_url": "https://families.decal.ga.gov/ChildCare/detail/3122",
      "poi_directions_map_url": "https://maps.google.com/?cid=9925025307628847269&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-christian-academy",
      "poi_latitude": "32.0435725",
      "poi_longitude": "-81.1429662",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 912-234-4710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJib_WYOCf-4gRpcD6p-7FvIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c1320f89-eb3b-4944-9707-255dcb1a6792",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Trustees Theater",
      "poi_type": "Entertainment",
      "poi_address": "216 E Broughton St, Savannah, GA 31401, USA",
      "poi_short_description": "Landmark local playhouse with iconic marquee presenting classic films & live concerts since 1946.",
      "poi_long_description": "Landmark local playhouse with iconic marquee presenting classic films & live concerts since 1946.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-189b-738d-a47f-804ed0801e05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-189b-738d-a47f-804ed0801e05",
        "storage_key": "property/6767906449167459/019dfe3b-189b-738d-a47f-804ed0801e05.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.trusteestheater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12318599903209027660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trustees-theater",
      "poi_latitude": "32.078344",
      "poi_longitude": "-81.08912649999999",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-525-5051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-6642-708f-84ac-623435486642.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe3b-6642-708f-84ac-623435486642",
        "storage_key": "property/6767906449167459/019dfe3b-6642-708f-84ac-623435486642.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJwfr6CGWe-4gRTHjvYFh19Ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a9331b09-5f1f-4281-80a4-c4bf0e880748",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Savannah Theatre",
      "poi_type": "Entertainment",
      "poi_address": "222 Bull St, Savannah, GA 31401, USA",
      "poi_short_description": "Historic theater established in 1818 featuring a diverse line-up of musical plays & shows.",
      "poi_long_description": "Historic theater established in 1818 featuring a diverse line-up of musical plays & shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-18a5-71f8-86d1-3b91cc6a1a28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-18a5-71f8-86d1-3b91cc6a1a28",
        "storage_key": "property/6767906449167459/019dfe3b-18a5-71f8-86d1-3b91cc6a1a28.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savannahtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12411390908795783721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-theatre",
      "poi_latitude": "32.0758167",
      "poi_longitude": "-81.0924435",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-233-7764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTqMrmie-4gRKQpJ70UePqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_29f2de19-92d6-476b-978d-2f9871f478ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Lucas Theatre For the Arts",
      "poi_type": "Entertainment",
      "poi_address": "32 Abercorn St, Savannah, GA 31401, USA",
      "poi_short_description": "Revived 1920s theater hosts national & local stage productions, musical acts & film screenings.",
      "poi_long_description": "Revived 1920s theater hosts national & local stage productions, musical acts & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1add-70c0-bb27-e641543292cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1add-70c0-bb27-e641543292cb",
        "storage_key": "property/6767906449167459/019dfe3b-1add-70c0-bb27-e641543292cb.webp",
        "width": 1280,
        "height": 951
      },
      "poi_business_url": "https://www.lucastheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14397539329963391563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucas-theatre-for-the-arts",
      "poi_latitude": "32.0788098",
      "poi_longitude": "-81.0892985",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-525-5040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeQvlp2We-4gRS_ouOr1Vzsc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_3664e1df-e5dd-4f44-b842-420b43de5b17",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "SCAD Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "601 Turner Blvd, Savannah, GA 31401, USA",
      "poi_short_description": "Part of the Savannah College of Art & Design, this teaching museum displays modern art.",
      "poi_long_description": "Part of the Savannah College of Art & Design, this teaching museum displays modern art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dab2f-835e-7002-8736-640a9d7e96d0.webp",
      "poi_featured_image_media": {
        "alt_text": "Art gallery with paintings on display and people viewing.",
        "public_id": "019dab2f-835e-7002-8736-640a9d7e96d0",
        "storage_key": "property/6767906449167459/019dab2f-835e-7002-8736-640a9d7e96d0.webp",
        "width": 992,
        "height": 557
      },
      "poi_business_url": "https://www.scadmoa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10079924297740066703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scad-museum-of-art",
      "poi_latitude": "32.0775935",
      "poi_longitude": "-81.0994025",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-525-7191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e3-70ea-b4a1-2d1d29a664ec",
        "storage_key": "property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2I9T12e-4gRjx-gOb4V44s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_aa3bf134-168f-499f-9042-4b09fb204511",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Jepson Center & Telfair Children's Art Museum (CAM)",
      "poi_type": "Entertainment",
      "poi_address": "207 W York St, Savannah, GA 31401, USA",
      "poi_short_description": "Museum featuring modern paintings, photos & installations, plus an interactive gallery for kids.",
      "poi_long_description": "Museum featuring modern paintings, photos & installations, plus an interactive gallery for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1b57-70d7-862d-b08ae0d8a75b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1b57-70d7-862d-b08ae0d8a75b",
        "storage_key": "property/6767906449167459/019dfe3b-1b57-70d7-862d-b08ae0d8a75b.webp",
        "width": 1280,
        "height": 1001
      },
      "poi_business_url": "http://www.telfair.org/visit/jepson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16733686102627315117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jepson-center--telfair-childrens-art-museum-cam",
      "poi_latitude": "32.0782855",
      "poi_longitude": "-81.0951522",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-790-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e3-70ea-b4a1-2d1d29a664ec",
        "storage_key": "property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1g6smee-4gRre39-dn-Oeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_29b3fefc-640b-4140-8e1e-f90448739740",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Georgia State Railroad Museum",
      "poi_type": "Entertainment",
      "poi_address": "655 Louisville Rd, Savannah, GA 31401, USA",
      "poi_short_description": "This museum offers displays of historic railcars & rolling stock, plus guided tours & train rides.",
      "poi_long_description": "This museum offers displays of historic railcars & rolling stock, plus guided tours & train rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1bbd-76f7-9410-3ed4f564a77a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1bbd-76f7-9410-3ed4f564a77a",
        "storage_key": "property/6767906449167459/019dfe3b-1bbd-76f7-9410-3ed4f564a77a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chsgeorgia.org/GSRM",
      "poi_directions_map_url": "https://maps.google.com/?cid=9948865677916654689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-state-railroad-museum",
      "poi_latitude": "32.0754846",
      "poi_longitude": "-81.1015065",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-651-6823",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e3-70ea-b4a1-2d1d29a664ec",
        "storage_key": "property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55cUPUOe-4gRYUxMap94EYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ca31d6f0-803a-4f29-ba59-259f0d088fab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Savannah History Museum",
      "poi_type": "Entertainment",
      "poi_address": "303 Martin Luther King Jr Blvd, Savannah, GA 31401, USA",
      "poi_short_description": "Exhibits touching on local military, industry, art & culture, housed in a 19th-century railway shed.",
      "poi_long_description": "Exhibits touching on local military, industry, art & culture, housed in a 19th-century railway shed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1e64-74de-be78-7c770cf0d21a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1e64-74de-be78-7c770cf0d21a",
        "storage_key": "property/6767906449167459/019dfe3b-1e64-74de-be78-7c770cf0d21a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.chsgeorgia.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8993143764401227951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-history-museum",
      "poi_latitude": "32.0761781",
      "poi_longitude": "-81.0990726",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-651-6825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e3-70ea-b4a1-2d1d29a664ec",
        "storage_key": "property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-GnwUKe-4gRr4gnI5sQznw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d152daf8-04ca-4180-ac87-ee412a1a8f02",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Ships Of The Sea Maritime Museum",
      "poi_type": "Entertainment",
      "poi_address": "41 Martin Luther King Jr Blvd, Savannah, GA 31401, USA",
      "poi_short_description": "Ode to 18th- & 19th-century vessels in an 1819 home with a parlor garden & an event space.",
      "poi_long_description": "Ode to 18th- & 19th-century vessels in an 1819 home with a parlor garden & an event space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1ed7-7494-b5c1-13c9931c9d33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1ed7-7494-b5c1-13c9931c9d33",
        "storage_key": "property/6767906449167459/019dfe3b-1ed7-7494-b5c1-13c9931c9d33.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.shipsofthesea.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7649791718056594388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ships-of-the-sea-maritime-museum",
      "poi_latitude": "32.0811605",
      "poi_longitude": "-81.0972819",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-232-1511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e3-70ea-b4a1-2d1d29a664ec",
        "storage_key": "property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJlauZXWee-4gR1At9iAmFKWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a921332e-10d5-4a02-b8ca-9cc86c142539",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "District Live at Plant Riverside District",
      "poi_type": "Entertainment",
      "poi_address": "400 W River St, Savannah, GA 31401, USA",
      "poi_short_description": "Concerts by popular artists take place at this riverside venue with a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1c7a-707e-9a50-6133731eb85f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1c7a-707e-9a50-6133731eb85f",
        "storage_key": "property/6767906449167459/019dfe3b-1c7a-707e-9a50-6133731eb85f.webp",
        "width": 1280,
        "height": 623
      },
      "poi_business_url": "https://www.plantriverside.com/concerts-live-music/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13663237407059768997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "district-live-at-plant-riverside-district",
      "poi_latitude": "32.0838017",
      "poi_longitude": "-81.0961782",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-373-9150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIf7ZP4Sf-4gRpXag4QeSnb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_40d07dcb-5518-483d-9f05-621bc9963018",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Juliette Gordon Low Birthplace Museum",
      "poi_type": "Entertainment",
      "poi_address": "10 E Oglethorpe Ave, Savannah, GA 31401, USA",
      "poi_short_description": "Birthplace of the Girl Scout's founder offers tours of the Regency-style house, plus a gift shop.",
      "poi_long_description": "Birthplace of the Girl Scout's founder offers tours of the Regency-style house, plus a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-1ecd-75f3-ae2f-bf5f45e85f25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-1ecd-75f3-ae2f-bf5f45e85f25",
        "storage_key": "property/6767906449167459/019dfe3b-1ecd-75f3-ae2f-bf5f45e85f25.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.juliettegordonlowbirthplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11030815792586278212&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "juliette-gordon-low-birthplace-museum",
      "poi_latitude": "32.0770889",
      "poi_longitude": "-81.0924014",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-233-4501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e3-70ea-b4a1-2d1d29a664ec",
        "storage_key": "property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbsMBWae-4gRRMXfA4VUFZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_2c9d2697-1ad9-453d-afc5-0ab941354189",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Urgent Care of Berwick",
      "poi_type": "Health and Wellness",
      "poi_address": "5730 Ogeechee Rd #192, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-20d4-710c-b3fd-8e8ba11073dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-20d4-710c-b3fd-8e8ba11073dd",
        "storage_key": "property/6767906449167459/019dfe3b-20d4-710c-b3fd-8e8ba11073dd.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.urgentcarefamily.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9717555445762083181&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urgent-care-of-berwick",
      "poi_latitude": "32.0264167",
      "poi_longitude": "-81.22622919999999",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-201-1140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlZdJc0EK-4gRbcnPLTGx24Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_ba0af4e1-6d4e-4ba0-95cc-55e90a4fbfd5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Express Drugs Savannah Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "824 E Derenne Ave, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-30ca-7758-9f57-ef30bf92fd5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-30ca-7758-9f57-ef30bf92fd5f",
        "storage_key": "property/6767906449167459/019dfe3b-30ca-7758-9f57-ef30bf92fd5f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5877416253677885170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "express-drugs-savannah-pharmacy",
      "poi_latitude": "32.0255297",
      "poi_longitude": "-81.0960848",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-777-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-663c-70c8-80cb-98c9e1b14513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe3b-663c-70c8-80cb-98c9e1b14513",
        "storage_key": "property/6767906449167459/019dfe3b-663c-70c8-80cb-98c9e1b14513.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__9AZ-t1-4gR8taTXfHGkFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_67c6be12-67d1-48c1-9459-9c2fbebee4fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Medical Center Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4700 Waters Ave, Savannah, GA 31404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-21ac-750f-bbcb-cd047fef7bfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-21ac-750f-bbcb-cd047fef7bfc",
        "storage_key": "property/6767906449167459/019dfe3b-21ac-750f-bbcb-cd047fef7bfc.webp",
        "width": 960,
        "height": 350
      },
      "poi_business_url": "https://medicalcenterpharmacy1.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17671208734938694905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-center-pharmacy",
      "poi_latitude": "32.031092",
      "poi_longitude": "-81.0887249",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-350-6337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-663c-70c8-80cb-98c9e1b14513.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe3b-663c-70c8-80cb-98c9e1b14513",
        "storage_key": "property/6767906449167459/019dfe3b-663c-70c8-80cb-98c9e1b14513.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3QMpKPB1-4gR-QTN5be-PPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_31058bbc-0716-4528-8f0e-7a6a7722390d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3609 Ogeechee Rd, Savannah, GA 31405, USA",
      "poi_short_description": "Chain gym with a wide range of equipment, including massage chairs, and tanning.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dab2f-a4ab-7198-b160-2cb34611efef.webp",
      "poi_featured_image_media": {
        "alt_text": "People working out on various machines in a brightly lit gym.",
        "public_id": "019dab2f-a4ab-7198-b160-2cb34611efef",
        "storage_key": "property/6767906449167459/019dab2f-a4ab-7198-b160-2cb34611efef.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/savannah-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2869411139373950372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.0506622",
      "poi_longitude": "-81.1442641",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 912-231-3733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUwuB1uCf-4gRpOXufDoy0ic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d6e5d058-2e24-4a57-bb4b-eb04006606a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Blitz45 Fitness Savannah",
      "poi_type": "Health and Wellness",
      "poi_address": "4809 Waters Ave, Savannah, GA 31404, USA",
      "poi_short_description": "Fitness center offering workouts for all levels, plus challenges, events and happy hours.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-23e1-770a-bf33-1beb3027de74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-23e1-770a-bf33-1beb3027de74",
        "storage_key": "property/6767906449167459/019dfe3b-23e1-770a-bf33-1beb3027de74.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://blitz45fitnesssavannah.com/#",
      "poi_directions_map_url": "https://maps.google.com/?cid=11756274383874296594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blitz45-fitness-savannah",
      "poi_latitude": "32.0307077",
      "poi_longitude": "-81.0928409",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-547-2298",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVzg-ax91-4gREgvaxEOtJqM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_17dd797e-33e1-4f43-b22f-0088044db1fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "The Hub Boutique Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "4505 Habersham St, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-24a4-73f9-9a56-4d44ace1b54a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-24a4-73f9-9a56-4d44ace1b54a",
        "storage_key": "property/6767906449167459/019dfe3b-24a4-73f9-9a56-4d44ace1b54a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://thehubsavannah.squarespace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7796702530520616747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hub-boutique-studio",
      "poi_latitude": "32.0366264",
      "poi_longitude": "-81.1030251",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 912-414-1553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTd8EHox1-4gRKw8Sj6RzM2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_4617c1b7-ff42-4d4b-b506-5ee4146cb9fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Soulshine Pilates Yoga & Wellness",
      "poi_type": "Health and Wellness",
      "poi_address": "80 Wedgefield Crossing, Savannah, GA 31405, USA",
      "poi_short_description": "Studio offering Pilates, yoga, and wellness classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-2580-7688-a88e-955c7c547d91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-2580-7688-a88e-955c7c547d91",
        "storage_key": "property/6767906449167459/019dfe3b-2580-7688-a88e-955c7c547d91.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soulshinepilatesandyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4384000335923857175&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soulshine-pilates-yoga--wellness",
      "poi_latitude": "32.0666773",
      "poi_longitude": "-81.21165859999999",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 317-506-8555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrfQIN8mh-4gRF0fv_RMZ1zw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c34eb912-ae2b-4a84-b96d-caf13f455dce",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Daffin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "E Victory Dr, Savannah, GA 31404, USA",
      "poi_short_description": "Spacious park with athletic fields & courts, plus a pool, lakeside walking trail & shaded dog run.",
      "poi_long_description": "Spacious park with athletic fields & courts, plus a pool, lakeside walking trail & shaded dog run.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-a560-7258-b7b8-912a1ac980b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe37-a560-7258-b7b8-912a1ac980b6",
        "storage_key": "property/6767906449167459/019dfe37-a560-7258-b7b8-912a1ac980b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.savannahga.gov/2957/Recreation-and-Leisure-Services",
      "poi_directions_map_url": "https://maps.google.com/?cid=10299007936776474142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daffin-park",
      "poi_latitude": "32.045328",
      "poi_longitude": "-81.0815665",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-351-3841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e6-75bc-ab21-6d0b3dd359ff",
        "storage_key": "property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjeNjUQCe-4gRHo596iZt7Y4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9459b9b0-f11f-4b15-8cad-6f10402d6160",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Lake Mayer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1850 E Montgomery Cross Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Park with a lake offering picnic areas, a playground, tennis courts, and a skateboarding area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-2557-74b5-ad27-a53224bbb4f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-2557-74b5-ad27-a53224bbb4f9",
        "storage_key": "property/6767906449167459/019dfe3b-2557-74b5-ad27-a53224bbb4f9.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://parks.chathamcountyga.gov/CommunityParks/LakeMayer",
      "poi_directions_map_url": "https://maps.google.com/?cid=1999149330770112106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-mayer-park",
      "poi_latitude": "31.992331",
      "poi_longitude": "-81.08626799999999",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 912-652-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e6-75bc-ab21-6d0b3dd359ff",
        "storage_key": "property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQSN4wkl1-4gRai6Dcblnvhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_32c784e2-a889-4df9-a1f0-0e53fad7ef9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Bacon Park Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Shorty Cooper Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Golf links offering a mix of holes and featuring a driving range and putting green.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-26f4-72dd-8bec-a56e5b5b1d2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-26f4-72dd-8bec-a56e5b5b1d2d",
        "storage_key": "property/6767906449167459/019dfe3b-26f4-72dd-8bec-a56e5b5b1d2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.baconparkgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4019286711186714640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bacon-park-golf-course",
      "poi_latitude": "32.0066203",
      "poi_longitude": "-81.0819769",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-354-2625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-663a-7112-a2ad-b4e9060477ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe3b-663a-7112-a2ad-b4e9060477ba",
        "storage_key": "property/6767906449167459/019dfe3b-663a-7112-a2ad-b4e9060477ba.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJTdIHEcV1-4gREHC7_vdfxzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_af515232-3248-4bbc-8764-0a2badce7a99",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Forsyth Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Savannah, GA 31401, USA",
      "poi_short_description": "30-acre park with basketball & tennis courts, paths, a historic fountain & a Confederate memorial.",
      "poi_long_description": "30-acre park with basketball & tennis courts, paths, a historic fountain & a Confederate memorial.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-a2ec-7332-a339-cd450d838d04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe37-a2ec-7332-a339-cd450d838d04",
        "storage_key": "property/6767906449167459/019dfe37-a2ec-7332-a339-cd450d838d04.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.savannahga.gov/351/Parks-Playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=16070509674831716323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forsyth-park",
      "poi_latitude": "32.0675356",
      "poi_longitude": "-81.09623839999999",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-351-3841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e6-75bc-ab21-6d0b3dd359ff",
        "storage_key": "property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj52mkmqe-4gR45_Sb2frBd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_182d3fea-c675-4c13-bd1e-c94c11c83413",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Bonaventure Cemetery",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "330 Bonaventure Rd, Savannah, GA 31404, USA",
      "poi_short_description": "Tree-filled cemetery immortalized in best-selling \"Midnight in the Garden of Good and Evil\" novel.",
      "poi_long_description": "Tree-filled cemetery immortalized in best-selling \"Midnight in the Garden of Good and Evil\" novel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-2e7b-7041-9f8d-4ab2497c7817.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-2e7b-7041-9f8d-4ab2497c7817",
        "storage_key": "property/6767906449167459/019dfe3b-2e7b-7041-9f8d-4ab2497c7817.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.savannahga.gov/Cemeteries",
      "poi_directions_map_url": "https://maps.google.com/?cid=16627136189079936711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonaventure-cemetery",
      "poi_latitude": "32.0452285",
      "poi_longitude": "-81.0506399",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 912-651-6843",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-6651-7238-89b2-68aac6eb4c9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe3b-6651-7238-89b2-68aac6eb4c9c",
        "storage_key": "property/6767906449167459/019dfe3b-6651-7238-89b2-68aac6eb4c9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJexSTgYyd-4gRx94mBkV0v-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cemetery"
    },
    {
      "id": "custom_7eab3697-cd67-4d5f-abc9-1ee7ffd8334a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Savannah Ogeechee Canal Museum and Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "681 Fort Argyle Rd, Savannah, GA 31419, USA",
      "poi_short_description": "Museum charting the history of an 1880s commercial canal, with models & remains of its locks.",
      "poi_long_description": "Museum charting the history of an 1880s commercial canal, with models & remains of its locks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-2b57-70aa-bd58-627b318f07a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-2b57-70aa-bd58-627b318f07a3",
        "storage_key": "property/6767906449167459/019dfe3b-2b57-70aa-bd58-627b318f07a3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.savannahogeecheecanal.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3306472962369169396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-ogeechee-canal-museum-and-nature-center",
      "poi_latitude": "32.0231191",
      "poi_longitude": "-81.3167919",
      "poi_miles_from_property": "19.8",
      "poi_walking_minutes": "7 hours 16 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-748-8068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e3-70ea-b4a1-2d1d29a664ec",
        "storage_key": "property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJwXT4FV0I-4gR9KdyDaTz4i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_64d1c35d-03da-447d-a0ec-87adc2fc8234",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Oatland Island Wildlife Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "711 Sandtown Rd, Savannah, GA 31410, USA",
      "poi_short_description": "Compact, zoo-like preserve with dozens of species in natural habitats, plus education programs.",
      "poi_long_description": "Compact, zoo-like preserve with dozens of species in natural habitats, plus education programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-2b46-742e-805d-b406d622b603.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-2b46-742e-805d-b406d622b603",
        "storage_key": "property/6767906449167459/019dfe3b-2b46-742e-805d-b406d622b603.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oatland.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12055131803854154654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oatland-island-wildlife-center",
      "poi_latitude": "32.049159",
      "poi_longitude": "-81.02449969999999",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 912-395-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e6-75bc-ab21-6d0b3dd359ff",
        "storage_key": "property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKz5cUG6d-4gRnqs9OYFuTKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_park"
    },
    {
      "id": "custom_3d868c5c-cf9d-4308-85b8-1dad3dd44313",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Whitemarsh Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "68 Johnny Mercer Blvd, Savannah, GA 31410, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-30cb-7631-ac68-28da6a36b977.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-30cb-7631-ac68-28da6a36b977",
        "storage_key": "property/6767906449167459/019dfe3b-30cb-7631-ac68-28da6a36b977.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parks.chathamcountyga.gov/NaturePreserves/WhitemarshPreserve",
      "poi_directions_map_url": "https://maps.google.com/?cid=2472080345945786074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whitemarsh-preserve",
      "poi_latitude": "32.0315491",
      "poi_longitude": "-80.99928729999999",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 912-652-6780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e6-75bc-ab21-6d0b3dd359ff",
        "storage_key": "property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzdsHV-R3-4gR2sZSHPqXTiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_aee73851-49a6-4196-9c56-e4f69b697f3b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Wormsloe State Historic Site",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7601 Skidaway Rd, Savannah, GA 31406, USA",
      "poi_short_description": "Historic site featuring the ruins of a Colonial estate, gardens, trails & an oak-lined driveway.",
      "poi_long_description": "Historic site featuring the ruins of a Colonial estate, gardens, trails & an oak-lined driveway.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-2e59-77be-9a06-6dd5d1bf8413.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-2e59-77be-9a06-6dd5d1bf8413",
        "storage_key": "property/6767906449167459/019dfe3b-2e59-77be-9a06-6dd5d1bf8413.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://gastateparks.org/Wormsloe",
      "poi_directions_map_url": "https://maps.google.com/?cid=10012291246731543177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wormsloe-state-historic-site",
      "poi_latitude": "31.9801601",
      "poi_longitude": "-81.0692663",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 912-353-3023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e3-70ea-b4a1-2d1d29a664ec",
        "storage_key": "property/6767906449167459/019dfe37-b8e3-70ea-b4a1-2d1d29a664ec.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30Ccw5x2-4gRicIvbdfN8oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_123bdbf4-d55d-47c8-8b70-cf56f7781592",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Skidaway Island State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "52 Diamond Causeway, Savannah, GA 31411, USA",
      "poi_short_description": "A waterfront park offering camping (including cabins), nature programs, trails & a viewing tower.",
      "poi_long_description": "A waterfront park offering camping (including cabins), nature programs, trails & a viewing tower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-33e2-709d-acdf-5b385d962e72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-33e2-709d-acdf-5b385d962e72",
        "storage_key": "property/6767906449167459/019dfe3b-33e2-709d-acdf-5b385d962e72.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://gastateparks.org/SkidawayIsland",
      "poi_directions_map_url": "https://maps.google.com/?cid=16471744632454584550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skidaway-island-state-park",
      "poi_latitude": "31.95476559999999",
      "poi_longitude": "-81.0525755",
      "poi_miles_from_property": "14",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 912-598-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e6-75bc-ab21-6d0b3dd359ff",
        "storage_key": "property/6767906449167459/019dfe37-b8e6-75bc-ab21-6d0b3dd359ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5TuGrZ2-4gR5hhn4Hhkl-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_45af7e00-d680-4364-8db6-624c28dd13d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Garrard & Brandlewood NB",
      "poi_type": "Transportation & Transit",
      "poi_address": "Georgia 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-33e6-778e-a29e-8f55091706a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-33e6-778e-a29e-8f55091706a5",
        "storage_key": "property/6767906449167459/019dfe3b-33e6-778e-a29e-8f55091706a5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11643113224461339695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garrard--brandlewood-nb",
      "poi_latitude": "32.042035",
      "poi_longitude": "-81.156804",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyYRTtVZ1-4gRL8yrL8qllKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_7d1a171f-b4f7-4e94-b9ed-02d550563f60",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Chatham Area Transit Authority (CAT)",
      "poi_type": "Transportation & Transit",
      "poi_address": "610 W Oglethorpe Ave, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-3246-753e-ac15-8a818e013b11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-3246-753e-ac15-8a818e013b11",
        "storage_key": "property/6767906449167459/019dfe3b-3246-753e-ac15-8a818e013b11.webp",
        "width": 800,
        "height": 549
      },
      "poi_business_url": "http://www.catchacat.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7892773447189232483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chatham-area-transit-authority-cat",
      "poi_latitude": "32.0792723",
      "poi_longitude": "-81.1001088",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL-CJxwye-4gRY3tZ7KHDiG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_13621f86-d52e-4967-87e4-fc784f821d11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Ogeechee & Chatham Pkwy NB",
      "poi_type": "Transportation & Transit",
      "poi_address": "Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12265300921770384070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ogeechee--chatham-pkwy-nb",
      "poi_latitude": "32.048508",
      "poi_longitude": "-81.16475899999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjVYnEgCg-4gRxhplOTQaN6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_1179e576-00f7-4dda-9c6d-f0ddce7cd4c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Joe Murray Rivers, Jr. Intermodal Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "W Oglethorpe Ave, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-326b-73a7-aa08-dd2a85e07689.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-326b-73a7-aa08-dd2a85e07689",
        "storage_key": "property/6767906449167459/019dfe3b-326b-73a7-aa08-dd2a85e07689.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "http://www.catchacat.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7901387300494243883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joe-murray-rivers-jr-intermodal-transit-center",
      "poi_latitude": "32.0795155",
      "poi_longitude": "-81.0998743",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-6655-7151-95ac-527dec0d1a20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe3b-6655-7151-95ac-527dec0d1a20",
        "storage_key": "property/6767906449167459/019dfe3b-6655-7151-95ac-527dec0d1a20.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJx6fx-Fye-4gRK_i97uJdp20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_cccc1186-c045-4c09-a224-7b0c3e05dfe4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Chatham Area Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "900 E Gwinnett St, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-3576-732a-9b4b-b1306744cef8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-3576-732a-9b4b-b1306744cef8",
        "storage_key": "property/6767906449167459/019dfe3b-3576-732a-9b4b-b1306744cef8.webp",
        "width": 1073,
        "height": 1121
      },
      "poi_business_url": "http://www.catchacat.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14211752328539634895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chatham-area-transit",
      "poi_latitude": "32.0637541",
      "poi_longitude": "-81.0813304",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQLY82Se-4gRz3xvGnJJOsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_ceb1d96a-fcf7-4035-9290-fdd060e5b073",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Savannah",
      "poi_type": "Transportation & Transit",
      "poi_address": "2611 Seaboard Coastline Dr, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-aad7-7739-96eb-26e86cb48d2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe37-aad7-7739-96eb-26e86cb48d2d",
        "storage_key": "property/6767906449167459/019dfe37-aad7-7739-96eb-26e86cb48d2d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=SAV",
      "poi_directions_map_url": "https://maps.google.com/?cid=1136550232795717085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah",
      "poi_latitude": "32.083701",
      "poi_longitude": "-81.1485479",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-bb6b-714c-b9e6-912f91211d8d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-bb6b-714c-b9e6-912f91211d8d",
        "storage_key": "property/6767906449167459/019dfe37-bb6b-714c-b9e6-912f91211d8d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbNe15mf-4gR3R0tP2rWxQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_8e012cc9-c490-4cc1-9d77-4336188976d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Savannah Belles Ferry Stop, Trade Center Landing",
      "poi_type": "Transportation & Transit",
      "poi_address": "4032 International Dr, Savannah, GA 31402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-384d-74f2-abfe-888e883d4c8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-384d-74f2-abfe-888e883d4c8f",
        "storage_key": "property/6767906449167459/019dfe3b-384d-74f2-abfe-888e883d4c8f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.catchacat.org/getting-around/ride-free-downtown/savannah-belles-ferry/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12317820752603385558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-belles-ferry-stop-trade-center-landing",
      "poi_latitude": "32.0833485",
      "poi_longitude": "-81.0863542",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-233-5767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wcFy3ye-4gR1g7cPbaw8ao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferry_service"
    },
    {
      "id": "custom_0cccac9a-9dcb-4de0-86d3-558b101278fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Oglethorpe Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7804 Abercorn Extention, Savannah, GA 31406, USA",
      "poi_short_description": "Big shopping mall featuring department stores, name-brand retailers, a food court & restaurants.",
      "poi_long_description": "Big shopping mall featuring department stores, name-brand retailers, a food court & restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dab2f-31e9-778d-a3a8-4f926238b361.webp",
      "poi_featured_image_media": {
        "alt_text": "Oglethorpe Mall entrance with Kirkland's store signage",
        "public_id": "019dab2f-31e9-778d-a3a8-4f926238b361",
        "storage_key": "property/6767906449167459/019dab2f-31e9-778d-a3a8-4f926238b361.webp",
        "width": 2039,
        "height": 1147
      },
      "poi_business_url": "https://www.oglethorpemall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8202028011205318403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oglethorpe-mall",
      "poi_latitude": "32.0027718",
      "poi_longitude": "-81.11702799999999",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "142",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 912-629-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-78546d3f4694.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-78546d3f4694",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-78546d3f4694.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHafA_6p1-4gRA1eyHQV103E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_087a723f-a1b9-4aa2-ad56-3922ea68c607",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Savannah Technical College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5717 White Bluff Rd, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dab2f-8181-708d-bfdc-269076a17c72.webp",
      "poi_featured_image_media": {
        "alt_text": "Graduation ceremony with students in caps and gowns.",
        "public_id": "019dab2f-8181-708d-bfdc-269076a17c72",
        "storage_key": "property/6767906449167459/019dab2f-8181-708d-bfdc-269076a17c72.webp",
        "width": 2048,
        "height": 1726
      },
      "poi_business_url": "https://www.savannahtech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7052498624589095008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-technical-college",
      "poi_latitude": "32.0235786",
      "poi_longitude": "-81.1141815",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-443-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdS0rI591-4gRYGCQISKC32E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2a7cb0fa-b1ca-4973-8f8c-b336f4ca165d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Candler Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5353 Reynolds St, Savannah, GA 31405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-a17a-77c2-9e84-7da007082eab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe37-a17a-77c2-9e84-7da007082eab",
        "storage_key": "property/6767906449167459/019dfe37-a17a-77c2-9e84-7da007082eab.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sjchs.org/locations/locationdetails/candler-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=12058112974386619187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "candler-hospital",
      "poi_latitude": "32.0281014",
      "poi_longitude": "-81.1003141",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 912-819-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8bd-70e1-825f-ab824b2f5c6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8bd-70e1-825f-ab824b2f5c6d",
        "storage_key": "property/6767906449167459/019dfe37-b8bd-70e1-825f-ab824b2f5c6d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpb2fD5N1-4gRM-PXE90FV6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2a49fa45-31dd-4594-8934-944fbab64150",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Memorial Health University Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4700 Waters Ave, Savannah, GA 31404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dab2f-d30e-71e9-9a1f-97b4ff882bde.webp",
      "poi_featured_image_media": {
        "alt_text": "Main entrance and exterior of a hospital building.",
        "public_id": "019dab2f-d30e-71e9-9a1f-97b4ff882bde",
        "storage_key": "property/6767906449167459/019dab2f-d30e-71e9-9a1f-97b4ff882bde.webp",
        "width": 564,
        "height": 317
      },
      "poi_business_url": "https://www.memorialhealth.com/locations/memorial-health-university-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4320841453139011030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-health-university-medical-center",
      "poi_latitude": "32.0303424",
      "poi_longitude": "-81.089434",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-350-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8bd-70e1-825f-ab824b2f5c6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8bd-70e1-825f-ab824b2f5c6d",
        "storage_key": "property/6767906449167459/019dfe37-b8bd-70e1-825f-ab824b2f5c6d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58O7Xe51-4gR1iUiqWi29js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4bcc4484-d08b-4ff9-a2e8-5c720566d10d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Savannah State University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3219 College St, Savannah, GA 31404, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dab2f-7ad5-7319-9b70-476cabafc663.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dab2f-7ad5-7319-9b70-476cabafc663",
        "storage_key": "property/6767906449167459/019dab2f-7ad5-7319-9b70-476cabafc663.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://savannahstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=170532476337488424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-state-university",
      "poi_latitude": "32.0241968",
      "poi_longitude": "-81.0625787",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 912-358-4162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp5BqurZ3-4gRKILDOmLaXQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_aff3d085-91cb-427a-b473-8740bca59bb2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Savannah College of Art and Design",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 Drayton St, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dab2f-74fe-73d0-8059-c12a31cc8294.webp",
      "poi_featured_image_media": {
        "alt_text": "Historic building exterior with ornate architectural details and columns, at dusk.",
        "public_id": "019dab2f-74fe-73d0-8059-c12a31cc8294",
        "storage_key": "property/6767906449167459/019dab2f-74fe-73d0-8059-c12a31cc8294.webp",
        "width": 1920,
        "height": 1278
      },
      "poi_business_url": "https://www.scad.edu/locations/savannah",
      "poi_directions_map_url": "https://maps.google.com/?cid=18151614706338739018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-college-of-art-and-design",
      "poi_latitude": "32.0691097",
      "poi_longitude": "-81.0938141",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-525-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFUzHD2me-4gRSrMTb2d95_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_68e6ad4b-e6a7-4f13-9a42-9b886a0e6a7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Savannah-Chatham County Public School System",
      "poi_type": "Major Employers & Offices",
      "poi_address": "208 Bull St, Savannah, GA 31401, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-3979-738c-82bc-a6e5d2e05c46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-3979-738c-82bc-a6e5d2e05c46",
        "storage_key": "property/6767906449167459/019dfe3b-3979-738c-82bc-a6e5d2e05c46.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sccpss.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14161313126219919229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-chatham-county-public-school-system",
      "poi_latitude": "32.0763392",
      "poi_longitude": "-81.0925851",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 912-395-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS41_p2ie-4gRfS9qKUIXh8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2f6c9ceb-d9f1-43a5-8c45-f250c263e6f1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Georgia Southern University Armstrong Campus Savannah",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11935 Abercorn St, Savannah, GA 31419, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dab2f-6629-7782-8cd0-9977d7045f35.webp",
      "poi_featured_image_media": {
        "alt_text": "Signage for Armstrong, Compass Point Windward Commons, and Athletic/Recreational Fields.",
        "public_id": "019dab2f-6629-7782-8cd0-9977d7045f35",
        "storage_key": "property/6767906449167459/019dab2f-6629-7782-8cd0-9977d7045f35.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.georgiasouthern.edu/campuses/armstrong-campus-savannah/",
      "poi_directions_map_url": "https://maps.google.com/?cid=783516353767565760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-southern-university-armstrong-campus-savannah",
      "poi_latitude": "31.9786073",
      "poi_longitude": "-81.1634639",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 912-478-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8e2-7002-807c-11fcedfc9785",
        "storage_key": "property/6767906449167459/019dfe37-b8e2-7002-807c-11fcedfc9785.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ9h8y0oL-4gRwGkG9vib3wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5409d4d8-fd9d-4947-909d-422a2df669e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Gulfstream Aerospace Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Gulfstream Rd, Savannah, GA 31408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-3a3f-738f-82be-e040e02e9ae1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-3a3f-738f-82be-e040e02e9ae1",
        "storage_key": "property/6767906449167459/019dfe3b-3a3f-738f-82be-e040e02e9ae1.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.gulfstream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14719559404661686851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulfstream-aerospace-corporation",
      "poi_latitude": "32.1392172",
      "poi_longitude": "-81.1973454",
      "poi_miles_from_property": "11.9",
      "poi_walking_minutes": "4 hours 21 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 912-965-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdeWtFyii-4gRQ8IefUphRsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_3b5ed2fd-c45d-445f-be69-bba60fa83048",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Georgia Ports Authority - Administrative Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2 Main St, Garden City, GA 31408, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-aad8-774f-9fd5-2b6ffff8ac7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe37-aad8-774f-9fd5-2b6ffff8ac7a",
        "storage_key": "property/6767906449167459/019dfe37-aad8-774f-9fd5-2b6ffff8ac7a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gaports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3663778410647710348&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-ports-authority---administrative-building",
      "poi_latitude": "32.1286475",
      "poi_longitude": "-81.15145869999999",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 912-964-3811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8b4-74b8-84a7-7e3367eedfd9",
        "storage_key": "property/6767906449167459/019dfe37-b8b4-74b8-84a7-7e3367eedfd9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdf78Ok-f-4gRjOpmjg1b2DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_33d54df6-bbbd-4ec9-ba40-bd5400f73f2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "poi_name": "Savannah/Hilton Head International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 Airways Ave, Savannah, GA 31408, USA",
      "poi_short_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_long_description": "Airport offering nonstop flights to various East Coast & Southern U.S. cities, plus shopping & food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe3b-555b-7542-b109-b2b38874a6e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dfe3b-555b-7542-b109-b2b38874a6e4",
        "storage_key": "property/6767906449167459/019dfe3b-555b-7542-b109-b2b38874a6e4.webp",
        "width": 1280,
        "height": 556
      },
      "poi_business_url": "https://savannahairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3301384233227292702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannahhilton-head-international-airport",
      "poi_latitude": "32.1294229",
      "poi_longitude": "-81.201871",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 912-964-0514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe37-b8df-77d1-93de-b3ed99411efa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dfe37-b8df-77d1-93de-b3ed99411efa",
        "storage_key": "property/6767906449167459/019dfe37-b8df-77d1-93de-b3ed99411efa.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRNnApyh-4gRHpCW-Hff0C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    }
  ],
  "office_hours": [
    {
      "id": "custom_82604d80-5f35-41c8-b5fe-a4ffa1afa615",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_cddd2d10-7aeb-4723-968e-d3610af52d9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_34fabf6c-bc9c-438e-a5da-02c7e956543d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_985db413-ff3f-4f20-beef-3b737247ff90",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a53cdd84-225d-457d-9919-bcee21fa6863",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f3172270-0ec6-47f6-9147-d30db68407f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_c1475c94-adc8-49ce-8758-8077a1c88d97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "rating": "4.0",
      "name": "Trevon",
      "text": "Love it perfect for my family\n",
      "date": "2026-04-09",
      "title": ""
    },
    {
      "id": "custom_c96f2449-a443-4da5-9245-e33f03fa3133",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "rating": "5.0",
      "name": "Tiffany",
      "text": "We are under new management and so far I have to say I am very impressed. I had an issue with my air conditioner. They sent someone out to look at it. The part was ordered and it was replaced the next morning really impressive job by Jonathan in maintenance. Thank you guys so much.",
      "date": "2025-12-09",
      "title": ""
    },
    {
      "id": "custom_c3c1bd2f-9d4e-422b-8d03-285816c407d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "rating": "5.0",
      "name": "Dalea",
      "text": "Staff is very nice professional and helpful! Thank yall for everything you do. Nothing is unnoticed!\n",
      "date": "2026-02-17",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019dfe40-6326-708b-972d-c199ccf6ddfb",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rrliving-linden-at-southover",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459"
    },
    {
      "lead_collector_id": "019e0309-ce2e-765b-908d-5abbdcffd480",
      "lead_source": "LANDING_PAGE",
      "name": "rrliving-linden-at-southover-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459"
    },
    {
      "lead_collector_id": "019f05e6-7468-7402-b6b1-55666b531fbc",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "savannah-apartments-in-unit-laundry-linden-southover",
      "search_query": "savannah apartments with in-unit laundry",
      "category": "Amenity",
      "h1_title": "Savannah Apartments with In-Unit Laundry",
      "h2_subtitle": "Explore modern Savannah apartments complete with in-unit laundry. Enjoy added convenience at Linden at Southover in Southwest Savannah.",
      "page_copy": "Welcome to Linden at Southover, where you can discover modern Savannah apartments with in-unit laundry. Nestled in the scenic Southwest Savannah area, our community offers spacious floor plans ranging from one to three bedrooms. Each unit is meticulously designed featuring high ceilings, stylish finishes, and the luxury of a private patio.\n\nOur residents love the convenience of having in-unit laundry, ensuring that laundry day is hassle-free. Beyond your apartment, enjoy a range of amenities including a resort-style pool, fitness center, and serene picnic areas perfect for socializing. Choose Linden at Southover for premier Savannah living and experience the perfect blend of comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Savannah Apartments with In-Unit Laundry",
      "seo_description": "Find Savannah apartments with in-unit laundry at Linden at Southover. Modern amenities and spacious living spaces await in Southwest Savannah.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-southwest-savannah-linden",
      "search_query": "dog friendly apartments in southwest savannah",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Southwest Savannah",
      "h2_subtitle": "Discover dog friendly apartments in Southwest Savannah. Linden at Southover welcomes your furry friends to a warm and inviting community.",
      "page_copy": "Linden at Southover offers dog-friendly apartments in Southwest Savannah with spacious one-, two-, and three-bedroom floor plans. Each apartment features high ceilings, stylish finishes, and thoughtfully designed living spaces.\n\nOur community includes outdoor areas that provide opportunities for walks and recreation with your pet. Residents also have access to amenities such as a resort-style pool, fitness center, and picnic areas. Linden at Southover combines pet-friendly living with modern apartment features and community amenities in a convenient Southwest Savannah location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Southwest Savannah",
      "seo_description": "Linden at Southover offers dog friendly apartments in Southwest Savannah. Enjoy modern amenities with your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "chatham-county-apartments-air-conditioning-linden",
      "search_query": "apartments with air conditioning in chatham county",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Chatham County",
      "h2_subtitle": "Discover comfortable living with air-conditioned apartments in Chatham County. Linden at Southover offers cool retreats in Savannah, GA.",
      "page_copy": "Experience ultimate comfort at Linden at Southover, where our apartments with air conditioning provide a refreshing escape in Chatham County. Located in Savannah's charming community, our one, two, and three-bedroom floor plans are perfect for those seeking spacious layouts with modern amenities. \n\nEach apartment is equipped with a central air conditioning system, ensuring a comfortable living environment year-round. Residents also enjoy a suite of features including elegant stainless-steel appliances, high ceilings, and stylish finishes. Along with air-conditioned interiors, our property offers amenities such as a resort-style pool, fitness center, and plenty of lush green spaces. Choose Linden at Southover to enjoy a serene, cool lifestyle in the heart of Chatham County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chatham County Apartments with Air Conditioning",
      "seo_description": "Find air-conditioned apartments in Chatham County at Linden at Southover. Enjoy modern amenities and a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "private-parking-apartments-near-31405-linden",
      "search_query": "secure parking apartments near 31405",
      "category": "Amenity",
      "h1_title": "Private Parking Apartments Near 31405",
      "h2_subtitle": "Linden at Southover provides a controlled-access, gated community with private parking near 31405.",
      "page_copy": "Linden at Southover offers apartments with convenient, private parking near the 31405 area. Located in Savannah, our community features one-, two-, and three-bedroom apartment homes with high ceilings, stylish finishes, and thoughtfully designed living spaces.\n\nResidents have access to on-site parking as well as a variety of community amenities, including a resort-style pool, fitness center, and picnic areas. Linden at Southover combines modern apartment features with convenient community amenities and easy access to shopping, dining, and entertainment throughout Savannah.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Private Parking Apartments Near 31405",
      "seo_description": "Discover apartments with private parking near 31405 at Linden at Southover. Enjoy convenient living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "luxury-apartments-pool-savannah-ga-linden",
      "search_query": "luxury apartments with pool in savannah ga",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Savannah GA",
      "h2_subtitle": "Experience luxury living with a pool in Savannah, GA. Linden at Southover offers stylish residences with resort-style amenities.",
      "page_copy": "Welcome to Linden at Southover, where our luxury apartments with a pool redefine upscale living in Savannah, GA. Set in a sought-after location, our community delivers elegance and comfort through thoughtfully designed one, two, and three-bedroom homes. High ceilings and stylish finishes accentuate each unit, creating a warm and inviting atmosphere.\n\nDive into leisure with our stunning resort-style pool, a centerpiece of our many amenities. Whether you're lounging by the water or spending time in our well-equipped fitness center, Linden at Southover offers a relaxing retreat. Our residents also enjoy serene picnic areas and beautifully maintained landscapes. Discover the pinnacle of luxury living in Savannah, GA with Linden at Southover.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Savannah GA",
      "seo_description": "Linden at Southover provides luxury apartments with a pool in Savannah, GA. Enjoy elegant living with first-rate amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-savannah-ga-linden",
      "search_query": "1 bedroom apartments savannah ga",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Savannah GA",
      "h2_subtitle": "Find charming 1-bedroom apartments in Savannah, GA at Linden at Southover. Enjoy modern designs with fantastic amenities.",
      "page_copy": "Discover the perfect 1-bedroom apartments in Savannah, GA at Linden at Southover, where modern design meets comfort. Situated in the welcoming community of Southwest Savannah, our one-bedroom floor plans offer spacious layouts with high ceilings and stylish finishes that make the ideal home.\n\nEach apartment is equipped with premium stainless steel appliances and a private patio, providing residents a blend of elegance and functionality. Beyond the walls of your apartment, enjoy access to our resort-style pool, state-of-the-art fitness center, and relaxing picnic areas. Experience the convenience and serenity of living at Linden at Southover, where your ideal 1 bedroom apartment awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Savannah GA",
      "seo_description": "Explore 1-bedroom apartments in Savannah, GA at Linden at Southover. Modern living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-southwest-savannah-linden",
      "search_query": "2 bedroom apartments southwest savannah",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Southwest Savannah",
      "h2_subtitle": "Explore spacious 2-bedroom apartments in Southwest Savannah at Linden at Southover. Stylish living with exceptional amenities awaits.",
      "page_copy": "For those seeking 2-bedroom apartments in Southwest Savannah, Linden at Southover offers an unparalleled living experience. Our thoughtfully designed two-bedroom floor plans boast ample space with high ceilings and elegant finishes, making them perfect for modern lifestyles.\n\nSituated in a vibrant neighborhood, our community not only provides beautiful living spaces but also exceptional amenities. Residents can bask in the sun by our resort-style pool, stay fit at the cutting-edge fitness center, or unwind at picturesque picnic areas. Enjoy the convenience and charm of residing in Southwest Savannah at Linden at Southover, where spacious two-bedroom apartments blend comfort with sophistication.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Southwest Savannah",
      "seo_description": "Discover spacious 2-bedroom apartments in Southwest Savannah at Linden at Southover. Experience stylish living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "3-bedroom-apartments-chatham-county-linden",
      "search_query": "3 bedroom apartments chatham county",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Chatham County",
      "h2_subtitle": "Discover spacious 3-bedroom apartments in Chatham County at Linden at Southover. ",
      "page_copy": "Linden at Southover offers 3-bedroom apartments in Chatham County with spacious floor plans, high ceilings, modern finishes, and private patio areas.\n\nResidents have access to community amenities including a resort-style pool, fitness center, and picnic areas. Located in Chatham County, Linden at Southover combines contemporary apartment features with convenient access to shopping, dining, recreation, and major roadways throughout the Savannah area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Chatham County",
      "seo_description": "Explore 3-bedroom apartments in Chatham County at Linden at Southover. Spacious living in a prime location with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "apartments-near-haven-elementary-school-savannah-linden",
      "search_query": "apartments near Haven Elementary School Savannah",
      "category": "School",
      "h1_title": "Apartments Near Haven Elementary School",
      "h2_subtitle": "Find ideal apartments and great amenities near Haven Elementary School in Savannah at Linden at Southover. ",
      "page_copy": "If you're searching for apartments near Haven Elementary School in Savannah, Linden at Southover offers a convenient location with access to nearby schools, shopping, dining, and local services. Our community features spacious one-, two-, and three-bedroom floor plans with high ceilings and modern finishes.\n\nResidents have access to amenities including a resort-style pool, fitness center, and picnic areas. Linden at Southover combines contemporary apartment features with convenient access to neighborhood destinations throughout Savannah.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Haven Elementary School",
      "seo_description": "Explore apartments near Haven Elementary School, Savannah, at Linden at Southover. Ideal location with inviting interiors and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "derenne-middle-school-nearby-apartments-savannah",
      "search_query": "DeRenne Middle School nearby apartments Savannah GA",
      "category": "School",
      "h1_title": "Apartments Near DeRenne Middle School",
      "h2_subtitle": "Discover nearby apartments to DeRenne Middle School in Savannah, GA at Linden at Southover. ",
      "page_copy": "For those searching for apartments near DeRenne Middle School in Savannah, GA, Linden at Southover offers a convenient location with access to nearby schools, shopping, dining, and local services. Our community features one-, two-, and three-bedroom floor plans with high ceilings, private patios, and modern finishes.\n\nResidents have access to amenities including a resort-style pool, fitness center, playground, and picnic areas. Linden at Southover combines contemporary apartment features with convenient access to neighborhood destinations throughout Savannah.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near DeRenne Middle School",
      "seo_description": "Find apartments near DeRenne Middle School, Savannah, GA at Linden at Southover. Perfect for anyone looking for convenient, stylish living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "jacob-g-smith-elementary-close-apartments-chatham",
      "search_query": "Jacob G. Smith Elementary School close apartments Chatham County",
      "category": "School",
      "h1_title": "Close Apartments to Jacob G. Smith Elementary",
      "h2_subtitle": "Discover pet-friendly apartments close to Jacob G. Smith Elementary School in Chatham County at Linden at Southover. ",
      "page_copy": "Looking for apartments close to Jacob G. Smith Elementary School in Chatham County? Linden at Southover offers a convenient location near local schools, shopping, dining, and everyday services. Our community features one-, two-, and three-bedroom floor plans with high ceilings and modern finishes.\n\nResidents have access to amenities including a resort-style pool, fitness center, and picnic areas. Linden at Southover combines contemporary apartment features with convenient access to neighborhood destinations throughout the Savannah area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close Apartments to Jacob G. Smith Elementary",
      "seo_description": "Explore pet-friendly apartments close to Jacob G. Smith Elementary School in Chatham County at Linden at Southover. ",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "mercer-middle-school-apartments-southwest-savannah",
      "search_query": "Mercer Middle School apartments in Southwest Savannah",
      "category": "School",
      "h1_title": "Apartments Near Mercer Middle School",
      "h2_subtitle": "Find quality apartments near Mercer Middle School in Southwest Savannah at Linden at Southover. Enjoy modern comforts and a prime location.",
      "page_copy": "If you're searching for apartments near Mercer Middle School in Southwest Savannah, Linden at Southover offers a convenient location with access to nearby schools, shopping, dining, and local services. Our community features one-, two-, and three-bedroom floor plans with high ceilings and stylish finishes.\n\nResidents have access to amenities including a resort-style pool, fitness center, and picnic areas. Linden at Southover combines contemporary apartment features with convenient access to neighborhood destinations throughout Savannah.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mercer Middle School",
      "seo_description": "Discover apartments near Mercer Middle School in Southwest Savannah at Linden at Southover. Enjoy stylish living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "alfred-e-beach-high-school-nearby-apartments-savannah-31405",
      "search_query": "Alfred E. Beach High School nearby apartments Savannah 31405",
      "category": "School",
      "h1_title": "Nearby Apartments to Alfred E. Beach High",
      "h2_subtitle": "Explore apartments near Alfred E. Beach High School in Savannah's 31405. Linden at Southover offers modern living with ideal convenience.",
      "page_copy": "Looking for apartments near Alfred E. Beach High School in Savannah 31405? Linden at Southover offers a convenient location near local schools, shopping, dining, and everyday services. Our community features one-, two-, and three-bedroom floor plans with high ceilings, private patios, and modern finishes.\n\nResidents have access to amenities including a resort-style pool, fitness center, and picnic areas. Linden at Southover combines contemporary apartment features with convenient access to neighborhood destinations throughout Savannah.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Alfred E. Beach High",
      "seo_description": "Find apartments near Alfred E. Beach High School in Savannah 31405 at Linden at Southover. Enjoy proximity and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "urban-christian-academy-close-apartments-savannah",
      "search_query": "Urban Christian Academy close apartments Savannah",
      "category": "School",
      "h1_title": "Close Apartments to Urban Christian Academy",
      "h2_subtitle": "Discover Linden at Southover for nearby apartments to Urban Christian Academy in Savannah. Experience a blend of modern living and convenience.",
      "page_copy": "Searching for apartments near Urban Christian Academy in Savannah? Linden at Southover offers a convenient location with access to nearby schools, shopping, dining, and local services. Our community features one-, two-, and three-bedroom floor plans with elegant finishes and private patios.\n\nResidents have access to amenities including a resort-style pool, fitness center, and picnic areas. Linden at Southover combines modern apartment features with convenient access to neighborhood destinations throughout Savannah.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Close Apartments to Urban Christian Academy",
      "seo_description": "Find nearby apartments to Urban Christian Academy in Savannah at Linden at Southover. Enjoy modern comforts and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "savannah-tech-college-accommodations-savannah",
      "search_query": "Savannah Technical College student accommodations Savannah",
      "category": "School",
      "h1_title": "Housing Near Savannah Tech College",
      "h2_subtitle": "Discover apartment homes near Savannah Technical College at Linden at Southover. Embrace modern living with educational convenience.",
      "page_copy": "Looking for apartments near Savannah Technical College? Linden at Southover offers a convenient location in Savannah with access to nearby educational institutions, shopping, dining, and everyday services. Our community features one-, two-, and three-bedroom floor plans with modern finishes and thoughtfully designed living spaces.\n\nResidents have access to amenities including a resort-style pool, fitness center, and picnic areas. Linden at Southover combines contemporary apartment features with convenient access to neighborhood destinations throughout Savannah.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Savannah Tech College",
      "seo_description": "Find apartment homes near Savannah Technical College at Linden at Southover. Enjoy comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "savannah-state-university-nearby-apartments-savannah-ga",
      "search_query": "Savannah State University nearby apartments Savannah GA",
      "category": "School",
      "h1_title": "Apartments Near Savannah State University",
      "h2_subtitle": "Linden at Southover offers nearby apartments to Savannah State University in GA. Enjoy modern living close to campus.",
      "page_copy": "Looking for apartments near Savannah State University in Savannah, GA? Linden at Southover offers a convenient location with access to nearby educational institutions, shopping, dining, and local attractions. Our community features one-, two-, and three-bedroom floor plans with stylish finishes and private patios.\n\nResidents have access to amenities including a resort-style pool, fitness center, and picnic areas. Linden at Southover combines modern apartment features with convenient access to destinations throughout the Savannah area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Savannah State University",
      "seo_description": "Discover nearby apartments to Savannah State University at Linden at Southover in GA. Experience modern living and campus convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "apartments-near-candler-hospital-savannah-ga",
      "search_query": "apartments near Candler Hospital Savannah GA",
      "category": "Hospital",
      "h1_title": "Live Close to Candler Hospital in Savannah",
      "h2_subtitle": "Linden at Southover features modern apartments near Candler Hospital in Savannah, GA.",
      "page_copy": "Looking for apartments near Candler Hospital in Savannah, GA? Linden at Southover offers a convenient location with easy access to Candler Hospital and other destinations throughout Savannah. Our community features one-, two-, and three-bedroom floor plans with stylish finishes and private patios.\n\nResidents have access to amenities including a resort-style pool, fitness center, and picnic areas. Linden at Southover combines modern apartment features with convenient access to nearby employers, shopping, dining, and local services.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Close to Candler Hospital in Savannah",
      "seo_description": "Find modern apartments near Candler Hospital in Savannah, GA at Linden at Southover.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "apartments-close-to-memorial-health-university-medical-center-chatham-county",
      "search_query": "apartments close to Memorial Health University Medical Center Chatham County",
      "category": "Hospital",
      "h1_title": "Stay Near Memorial Health University Med Center",
      "h2_subtitle": "Linden at Southover offers apartments close to Memorial Health University Medical Center in Chatham County for unmatched convenience and comfort.",
      "page_copy": "Linden at Southover offers apartments near Memorial Health University Medical Center in Chatham County. Our community features one-, two-, and three-bedroom floor plans with contemporary finishes and private patios.\n\nLocated minutes from Memorial Health University Medical Center, Linden at Southover provides convenient access to healthcare facilities, employers, shopping, dining, and local services throughout Savannah. Residents also have access to amenities including a resort-style pool, fitness center, and picnic areas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stay Near Memorial Health University Med Center",
      "seo_description": "Find apartments near Memorial Health University Medical Center in Chatham County at Linden at Southover. Enjoy comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "apartments-near-daffin-park-savannah",
      "search_query": "apartments near daffin park savannah",
      "category": "Park",
      "h1_title": "Live Near Daffin Park in Savannah",
      "h2_subtitle": "Discover Linden at Southover apartments near beautiful Daffin Park in Savannah. Enjoy green spaces and modern amenities.",
      "page_copy": "Experience the perfect blend of urban convenience and natural beauty at Linden at Southover, offering apartments near Daffin Park in Savannah. Our one, two, and three-bedroom units provide modern living spaces complete with elegant finishes and private patios, ideal for relaxing after a visit to the park.\n\nSituated close to Daffin Park, residents can enjoy easy access to outdoor recreation, making it perfect for those who love the outdoors. In addition to this prime location, our residents benefit from amenities such as a resort-style pool and a state-of-the-art fitness center, ensuring both an active and comfortable lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Near Daffin Park in Savannah",
      "seo_description": "Explore apartments near Daffin Park in Savannah at Linden at Southover. Enjoy green spaces and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "linden-at-southover-close-to-lake-mayer-park",
      "search_query": "linden at southover close to lake mayer park",
      "category": "Park",
      "h1_title": "Linden at Southover Near Lake Mayer Park",
      "h2_subtitle": "Experience Linden at Southover, perfectly situated close to Lake Mayer Park. Enjoy both outdoor adventures and modern apartment features.",
      "page_copy": "Discover the charm of Linden at Southover, located conveniently close to Lake Mayer Park. Our community offers spacious one, two, and three-bedroom apartments, each designed with modern finishes, high ceilings, and private patios, ideal for unwinding after a day in the park.\n\nLiving near Lake Mayer Park means you're just moments away from beautiful trails and serene waters, perfect for outdoor enthusiasts. At Linden at Southover, residents enjoy the perfect balance of nature and luxury with amenities like a resort-style pool and a fully equipped fitness center, making it a top choice in Savannah.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Linden at Southover Near Lake Mayer Park",
      "seo_description": "Choose Linden at Southover, close to Lake Mayer Park in Savannah, for a blend of outdoor adventure and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "savannah-apartments-near-forsyth-park",
      "search_query": "savannah apartments near forsyth park",
      "category": "Park",
      "h1_title": "Apartments Near Forsyth Park, Savannah",
      "h2_subtitle": "Linden at Southover offers Savannah apartments with easy access to Forsyth Park. Enjoy vibrant community and modern comforts.",
      "page_copy": "Linden at Southover provides the perfect location for those searching for Savannah apartments near Forsyth Park. Our community offers spacious one, two, and three-bedroom floor plans designed with high-end finishes and private outdoor spaces, perfect for enjoying Savannah’s beautiful weather.\n\nLiving near Forsyth Park means you're steps away from one of Savannah's most iconic green spaces, ideal for morning jogs or afternoon picnics. Beyond the prime location, Linden at Southover offers amenities such as a resort-style pool, a modern fitness center, and serene picnic areas, making it the perfect blend of city living and natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Forsyth Park, Savannah",
      "seo_description": "Find Savannah apartments near Forsyth Park at Linden at Southover. Enjoy a vibrant community with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449167459",
      "source": "custom",
      "page_item_url": "southwest-savannah-rentals-near-skidaway-island-state-park",
      "search_query": "southwest savannah rentals near skidaway island state park",
      "category": "Park",
      "h1_title": "Rentals Near Skidaway Island State Park",
      "h2_subtitle": "Find southwest Savannah rentals near the scenic Skidaway Island State Park. Perfect for those who love nature and modern conveniences.",
      "page_copy": "Discover the tranquility of Southwest Savannah with rentals near Skidaway Island State Park at Linden at Southover. Our spacious and elegantly designed one, two, and three-bedroom apartments boast stylish finishes, offering residents both comfort and luxury in a prime location.\n\nLiving close to Skidaway Island State Park means endless opportunities for hiking, bird watching, and enjoying the great outdoors. Linden at Southover enhances this lifestyle by providing residents with top-notch amenities like a resort-style pool, a contemporary fitness center, and beautiful picnic areas, making it an ideal choice for those who love both nature and modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
      "featured_image_media": {
        "alt_text": "Indoor lounge area with large windows overlooking the pool.",
        "public_id": "019dfe38-9848-711d-9547-46ffaedc73ec",
        "storage_key": "property/6767906449167459/019dfe38-9848-711d-9547-46ffaedc73ec.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Skidaway Island State Park",
      "seo_description": "Explore Southwest Savannah rentals near Skidaway Island State Park at Linden at Southover. Enjoy nature and elegance.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6289"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11715357605"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5666488"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TF7BX6R3"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "912-331-4736"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "912-913-5010"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "912-470-4313"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "912-452-5293"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "912-785-8756"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "912-493-1646"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "912-493-7921"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "912-520-7072"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "912-405-2712"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "912-500-6086"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "912-455-6346"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "912-520-4121"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "912-493-3673"
    },
    {
      "ID": "custom_knock_psocl_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=psocl"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "912-416-9651"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_knock_psocl_title",
      "type": "STRING",
      "value": "Paid Social"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "53883459436"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "912-737-4655"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "912-385-4685"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f1ff307df06e6411"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "912-455-7014"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_psocl_number",
      "type": "STRING",
      "value": "912-421-2158"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "912-785-8395"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "912-207-8817"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "912-361-7522"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "912-361-7589"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "912-513-8441"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.lindenatsouthover.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6767906449167459/019ed199-446c-7490-8a7d-83da6317cf91.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "912-590-1484"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "912-405-2712"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "6289",
  "custom_repli_id": "11715357605",
  "custom_realpage_id": "5666488",
  "custom_knock_a_link": "https://www.lindenatsouthover.com?utm_knock=a",
  "custom_knock_g_link": "https://www.lindenatsouthover.com?utm_knock=g",
  "custom_knock_r_link": "https://www.lindenatsouthover.com?utm_knock=r",
  "custom_knock_w_link": "https://www.lindenatsouthover.com?utm_knock=w",
  "custom_knock_z_link": "https://www.lindenatsouthover.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-TF7BX6R3",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_cl_link": "https://www.lindenatsouthover.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.lindenatsouthover.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.lindenatsouthover.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.lindenatsouthover.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "912-331-4736",
  "custom_knock_ads_link": "https://www.lindenatsouthover.com?utm_knock=ads",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "912-913-5010",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.lindenatsouthover.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.lindenatsouthover.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.lindenatsouthover.com?utm_knock=ppn",
  "custom_knock_r_number": "912-470-4313",
  "custom_knock_w_number": "912-452-5293",
  "custom_knock_z_number": "912-785-8756",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_cl_number": "912-493-1646",
  "custom_knock_fb_number": "912-493-7921",
  "custom_knock_fl_number": "912-520-7072",
  "custom_knock_gp_number": "912-405-2712",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.lindenatsouthover.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "912-500-6086",
  "custom_knock_bcard_link": "https://www.lindenatsouthover.com?utm_knock=bcard",
  "custom_knock_cfres_link": "https://www.lindenatsouthover.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "912-455-6346",
  "custom_knock_lgp_number": "912-520-4121",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.lindenatsouthover.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "912-493-3673",
  "custom_knock_psocl_link": "https://www.lindenatsouthover.com?utm_knock=psocl",
  "custom_seo_subscription": "essential",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.lindenatsouthover.com?utm_knock=flyers",
  "custom_knock_osoc_number": "912-416-9651",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_knock_psocl_title": "Paid Social",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "53883459436",
  "custom_knock_bcard_number": "912-737-4655",
  "custom_knock_cfres_number": "912-385-4685",
  "custom_knock_chatgpt_link": "https://www.lindenatsouthover.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "f1ff307df06e6411",
  "custom_knock_dirmail_link": "https://www.lindenatsouthover.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "912-455-7014",
  "custom_knock_propbro_link": "https://www.lindenatsouthover.com?utm_knock=propbro",
  "custom_knock_psocl_number": "912-421-2158",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "912-785-8395",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.lindenatsouthover.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "912-207-8817",
  "custom_knock_dirmail_number": "912-361-7522",
  "custom_knock_propbro_number": "912-361-7589",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "912-513-8441",
  "custom_knock_maintenance_link": "https://www.lindenatsouthover.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6767906449167459/019ed199-446c-7490-8a7d-83da6317cf91.mp4",
  "custom_knock_maintenance_number": "912-590-1484",
  "custom_ppc_tracking_phone_number": "912-405-2712"
};

export const generatedAt = '2026-10-07T17:13:14.002Z';
